/* globals window */
/* eslint-disable quote-props */
/* eslint-disable angular/window-service */

(function iife() {
	"use strict";

	var common = {
		exams: "Tentit",
		examTemplates: "Tenttimallit",
		rubrics: "Pisteytysoppaat",
		cancel: "Peruuta",
		studentCode: {
			base: "Opiskelijakoodi",
			new: "Uusi Opiskelijakoodi",
		},
	};

	window.DX.locales.fi = {
		"Required": "Edellytetään",
		"LogIn": "Kirjaudu sisään",
		"CreateAccount": "Luo tili",
		"ForgotPassword": "Unohditko salasanasi?",
		"LogInWithSkolon": "Kirjaudu sisään Skolonilla",
		"AboutTheCompany": "Yrityksestä",
		"TermsOfService": "käyttöehdot",
		"PrivacyPolicy": "Tietosuojakäytäntö",
		"CookiePolicy": "Evästekäytäntö",
		"RegisterTerms_part1": "Hyväksyn Digiexamin",
		"RegisterDone_part1": "Ennen kuin voit kirjautua tilillesi, sinun on vahvistettava sähköpostiosoitteesi.",
		"RegisterDone_part2": "Vahvista sähköpostisi avaamalla linkki, joka on lähetetty sähköpostiisi.",
		"HowWeWorkWithData_Intro": "Helppolukuisen tiedon siitä, mitä teemme tietojesi kanssa, löydät täältä:",
		"HowWeWorkWithData_LinkTitle": "Mitä teemme tietojen kanssa",
		"ChangeRole": "Vaihda rooli",
		"Overview": "Yleiskatsaus",
		"Support": "Tuki",
		"ErrorMessage": "Virheviesti",
		"Email": "Sähköposti",
		"Emails": "Sähköpostiviestit",
		"ConfirmEmail": "Vahvista sähköposti",
		"FirstName": "Etunimi",
		"LastName": "Sukunimi",
		"Password": "Salasana",
		"ConfirmPassword": "Vahvista salasana",
		"Back": "Takaisin",
		"ChoosePlaceToLogin": "Valitse paikka sisäänkirjautumiselle",
		"ChooseAndLogIn": "Valitse ja kirjaudu sisään",
		"Send": "Lähettää",
		"ForgotPassword_String1": "Syötä sähköpostiosoitteesi ja lähetämme sinulle linkin, jonka kautta voit asettaa uuden salasanan.",
		"YourAccountHasBeenCreated": "Tilisi on luotu",
		"ReturnToLogIn": "Palaa kirjautumiseen",
		"SessionExpiredLogInToContinue": "Istuntosi on vanhentunut. Kirjaudu sisään uudelleen jatkaaksesi siitä, mihin jäit.",
		"LoginFailed": "Kirjautuminen epäonnistui",
		"LoginFailedDescription": "Kirjautuminen epäonnistui, sähköposti tai salasana on virheellinen.",
		"LoginFailedDescription.Timeout": "Kirjautumisyritys aikakatkaistiin, yritä uudelleen.",
		"LoginFailedDescription.Throttled": "Olet yrittänyt kirjautua sisään liian monta kertaa 3 minuutin aikana. Odota muutama minuutti ja yritä uudelleen.",
		"PasswordResetLinkHasBeenSent": "Uuden salasanan asettamislinkki lähetetty",
		"ForgotPasswordLinkRequest_String1": "Jos sähköpostiosoitteella on olemassa käyttäjä, lähetämme sähköpostiin linkin, jonka avaat uuden salasanan valitsemiseksi tilillesi.",
		"ForgotPasswordLinkRequest_String2": "Tarkistathan roskapostikansiosi, jos sähköpostiviestiä ei löydy.",
		"ForgotPassword_String3": "Anna tilillesi uusi salasana.",
		"ForgotPassword_String4": "Voit nyt kirjautua tiliisi uudella salasanalla.",
		"SetPassword_String3": "Syötä salasana uudelle tilillesi.",
		"SetPassword_String4": "Voit nyt kirjautua tiliisi.",
		"YourAccountIsNowBeingVerified": "Tilisi on nyt aktivoitu",
		"ItMightTakeAWhile": "Tämä saattaa kestää hetken, odota ole hyvä.",
		"PleaseWait": "Odota hetki",
		"YourAccountIsNowVerified": "Tilisi on nyt aktivoitu!",
		"NotVerified": "Sähköpostiosoitetta ei ole vahvistettu.",
		"VerificationError_WrongCode": "Virheellinen vahvistuskoodi.",
		"AnErrorHasOccurred": "Tapahtui virhe",
		"RequiredField": "Pakollinen kenttä",
		"MustBeLongerThan1Char": "Täytyy olla pidempi kuin 1 merkki.",
		"MustBeLongerThan5Chars": "Täytyy olal pidempi kuin 7 merkkiä.",
		"MustBeValidEmail": "Oltava voimassa oleva sähköpostiosoite",
		"InvalidEmail": "Väärä sähköpostiosoite.",
		"EmailsAreNotAMatch": "Sähköpostiosoitteet eivät vastaa toisiaan",
		"YouCantShareToYourOwnMail": "Et voi jakaa omaan sähköpostiosoitteeseesi",
		"PasswordTooShort": "Salasanan on oltava vähintään 8 merkkiä",
		"PasswordTooLong": "Salasana ei voi olla yli 100 merkkiä pitkä",
		"PasswordWhitespace": "Salasana ei voi sisältää tyhjiä merkkejä",
		"PasswordsAreNotAMatch": "Salasanat eivät vastaa toisiaan",
		"PasswordCanNotBeOld": "Ei voi olla sama kuin vanha salasana",
		"PasswordCommon": "Salasana ei ole tarpeeksi monimutkainen tai se on liian yleinen. Kokeile ainutlaatuisempaa salasanaa.",
		"WrongPassword": "Väärä salasana",
		"Optional": "Valinnainen",
		"EmailAlreadyRegistered": "Tämä sähköpostiosoite on jo rekisteröity",
		"InviteEmailAlreadyRegistered": "Käyttäjä sähköpostiosoitteella {0} on jo rekisteröity",
		"Overview_String1": "Et ole vielä osallistunut kursseille, klikkaa alla olevaa nappia osallistuaksesi.",
		"ShowExamLibrary": "Näytä kirjasto",
		"HideExamLibrary": "Piilota kirjasto",
		"YourExams": "Tenttisi {0}",
		"YourExamLibrary": "Tenttikirjastosi",
		"StartNewExam": "Aloita uusi tentti",
		"InformationBox1": "Aloittaaksesi uuden tentin, avaa",
		"InformationBox2": "Digiexam-sovellus",
		"InformationBox3": "tietokoneellasi. Voit ladata ja asentaa sovelluksen",
		"InformationBox4": "tästä",
		"StartClientButton": "Avaa Digiexam-sovellus",
		"RefreshExamList": "Päivitä tenttiluettelo",
		"Date": "Päivämäärä",
		"Course": "Kurssi",
		"Courses": "Kurssit",
		"Status": "Tila",
		"Result": "Tulos",
		"NotPlanned": "Ei suunniteltu",
		"EnterANewClass": "Osalistu uudelle kurssille",
		"ThereAreNoActiveExams": "Ei aktiivisia tenttejä",
		"UnknownError": "Tuntematon virhe",
		"UnknownErrorTryAgain": "Tuntematon virhe, yritä uudelleen.",
		"Ok": "Ok",
		"OkIUnderstand": "Ok, ymmärrän",
		"ThereAreNoUngradedExams": "Ei arvostelemattomia tenttejä",
		"ConnectionToServerWasInterrupted": "Yhteys palvelimeen keskeytettiin",
		"ConnectionError_String1": "Olet menettänyt yhteyden palvelimeen. Tämä estää toimintojesi tallentamisen.",
		"ConnectionError_String2": "Ole varovainen, ettet menetä tietoja.",
		"ConnectionError_String3": "Tämän yhteyden menetyksen syyt voivat olla yksi monista, mutta todennäköisimpiä ovat;",
		"ConnectionError_String4": "Tietokoneesi on menettänyt yhteyden Internetiin, tarkista verkkokaapeli tai yritä muodostaa yhteys WiFiin uudelleen.",
		"ConnectionError_String5": "Verkossa on häiriöitä laitteesi ja palvelimenne välillä.",
		"ConnectionError_String6": "Palvelimemme ovat kovan kuormituksen alla.",
		"ConnectionError_String7": "Älä sulje selain-välilehteä, jos sinulla on tallentamattomia tietoja. Ota yhteyttä IT-tukeenne ja kysy, pystyvätkö he ratkaisemaan ongelman",
		"ConnectionError_String8": "Tämä ruutu sulkeutuu, kun yhteys toimii oikealla tavalla.",
		"Home": "Koti",
		"Classroom": "Luokkahuone",
		"CreateRole": "Luo rooli",
		"AssignRole": "Määritä rooli",
		"LogOut": "Kirjaudu ulos",
		"Settings": "Asetukset",
		"ChangePersonalData": "Muuta henkilötietoja",
		"InformationSaved": "Tiedot tallennettu!",
		"ChangePassword": "Vaihda salasana",
		"SetPassword": "Aseta salasana",
		"Save": "Tallenna",
		"SaveX": "Tallenna {0}",
		"SaveAndClose": "Tallenna ja sulje",
		"SaveChanges": "Tallenna muutokset",
		"YourCurrentPassword": "Nykyinen salasanasi",
		"NewPassword": "Uusi salasana",
		"ConfirmNewPassword": "Vahvista uusi salasana",
		"YourPasswordHasBeenChanged": "Salasanasi on vaihdettu!",
		"YourPasswordHasBeenSet": "Salasanasi on asetettu!",
		"PlanExam": "Suunnittele tentti",
		"PlanExams": "Suunnittele tenttejä",
		"ThereAreNoExams": "Tenttejä ei ole",
		"RemoveExam": "Poista tentti",
		"RemoveSharedExam": "Poista jaettu tentti",
		"RemoveRubric": "Poista pisteytysopas",
		"RemoveGradingShare": "Poista arviointiosuutesi",
		"DoYouWantToRemoveGradingShareForExam": "Haluatko poistaa arviointiosuutesi kokeesta {0}",
		"YesRemoveShare": "Kyllä, poista luokittelu",
		"ThePersonWhoSharedTheExamWillStillHaveAccessToIt": "Henkilöllä, joka jakoi tentin, on edelleen pääsy tenttiin.",
		"EditExam": "Muokkaa tenttiä",
		"UploadOfflineAnswerFile": "Lataa Offline-vastaustiedosto",
		"UploadOfflineAnswerFile_Description": "Lataa offline-vastaustiedostot opiskelijoille, jotka eivät pystyneet palauttamaan vastauksiaan online-tilassa.",
		"UploadOfflineAnswerFile_FileFormats": "Sallitut tiedostotyypit ovat .zip ja .dxr",
		"UploadOfflineAnswerFile_Error": "Yhtä tai useampaa tiedostoa ei voitu ladata",
		"UploadOfflineAnswerFile_Success": "Kaikki tiedostot on ladattu",
		"UploadOfflineAnswerFile_DropOrClickUpload": "Raahaa offline-vastaustiedostot tänne tai klikkaa lisätäksesi ne.",
		"UploadOfflineAnswerFile_UnpublishToUpload": "Tentti on julkaistu, piilota tentti ladataksesi offline-vastaustiedostot.",
		"Files": "Tiedostot",
		"Filename": "Tiedoston nimi",
		"StudentAnswers": "Opiskelija vastaa",
		"Students": "Opiskelijat",
		"Name": "Nimi",
		"StudentCode": common.studentCode.base,
		"NewStudentCode": common.studentCode.new,
		"Edit": "Muokata",
		"Monitor": "Valvo",
		"Schedule": "Ajoita",
		"Reschedule": "Ajoita uudelleen",
		"Start": "Aloita",
		"ShowMoreExamActions": "Näytä lisää tenttitoimia",
		"RemoveStudent": "Poista opiskelija",
		"RemoveStudentFromClass": "Poista opiskelija luokasta",
		"EditStudent": "Muokkaa opiskelijaa",
		"EditStudentCode": "Muokkaa opiskelijakoodia",
		"NoStudentsHaveRegisteredYet": "Ei vielä rekisteröityjä opiskelijoita.",
		"ClassIsExternallyManaged": "Tätä luokkaa ohjataan ulkoisesti eikä sitä voi muuttaa digiexamissa.",
		"ViewClass_String5": "Voit siirtää luokan arkistoon, jos sitä ei enää tarvita.",
		"CouldNotFindClass": "Luokkaa ei löytynyt.",
		"CouldNotFindClassYouSearchedFor": "Etsimääsi luokkaa ei löytynyt.",
		"Archive": "Arkisto",
		"Archive.noun": "Arkisto",
		"Dearchive": "Palauta arkistosta.",
		"Group": "Ryhmä",
		"Class": "Luokka",
		"Classes": "Luokat",
		"Hide": "Piilota",
		"Show": "Näytä",
		"DoYouReallyWantToDoThis": "Oletko varma, että haluat tehdä tämän?",
		"DoYouWannaRemoveX": "Oletko varma, että haluat poistaa \\{0}\\\"?\"",
		"DoYouWannaRemoveExam": "Haluatko varmasti poistaa \"{0}\"? Tätä toimintoa ei voi kumota.",
		"DoYouWannaRemoveStudent": "Oletko varma, että haluat poistaa opiskelijan?",
		"DoYouWannaRemoveStudents": "Oletko varma, että haluat poistaa opiskelijat?",
		"Confirm": "Vahvista",
		"Cancel": common.cancel,
		"ArchiveClass": "Arkistoluokka",
		"YouCanFindYourArchivedClassesInArchive": "Löydät arkistoimasi luokat arkistosta. Voit aina palauttaa luokat arkistosta.",
		"ClassWillNowBeDearchived": "Luokka löytyy taas luokkiesi alta.",
		"DearchiveClass": "Palauta luokka arkistosta.",
		"YesDearchive": "Kyllä, palauta arkistosta.",
		"NoCancel": "Ei, peruuta",
		"Library": "Kirjasto",
		"Subjects": "Aihe",
		"Type": "Tyyppi",
		"LatestWeek": "Viimeisin viikko",
		"LatestMonth": "Viimeinen kuukausi",
		"LatestYear": "Viimeisin vuosi",
		"SpecifyDate": "Määritä päivämäärä",
		"From": "Peräkkäin",
		"To": "Jllek",
		"Add": "Lisää",
		"AddX": "Lisää {0}",
		"NoFiltersActive": "Suodattimia ei lisätty",
		"ClearAllFilters": "Tyhjennä kaikki suodattimet",
		"Clear": "Tyhjennä",
		"YourLibraryIsEmptyCreateExams": "Et ole luonut yhtään tenttiä.",
		"YourLibraryIsEmptyCreateRubrics": "Et ole luonut yhtään pisteytysopasta.",
		"Between": "Välillä",
		"And": "ja",
		"Tag": "merkitse",
		"Matching": "yhteensopiva",
		"NamelessExam": "Nimetön tentti",
		"NamelessRubric": "Nimetön pisteytysopas",
		"Preview": "Esikatselu",
		"PreviewAndPrint": "Esikatselu / tulosta",
		"GoToGrading": "Mene arvioon",
		"PreviewProgress": "Esikatselun edistyminen",
		"ExamMonitoringView": "Tentin valvontanäkymä",
		"Select": "Valitse",
		"SelectThisExam": "Valitse tämä tentti",
		"Question": "Kysymys",
		"Questions": "Kysymykset",
		"QuestionX": "Kysymys {0}",
		"Close": "Sulje",
		"YourClasses": "Luokkasi",
		"YourClasses.NoClass": "Et ole luonut yhtään luokkaa, klikkaa yllä olevaa painiketta aloittaaksesi suunniteltujen tenttien kanssa.",
		"AddQuestion": "Lisää kysymys",
		"CreateExam": "Luo tentti",
		"CreateRubric": "Luo pisteytysopas",
		"CreateClass": "Luo luokka",
		"CreateCourse": "Luo kurssi",
		"CreateGroup": "Luo ryhmä",
		"YourCourses": "Kurssisi",
		"ArchivedClasses": "Arkistoidut luokat",
		"FilterClasses": "Suodata luokkia",
		"FilterCourses": "Suodata kursseja",
		"ArchivedGroups": "Arkistoidut ryhmät",
		"DragClassHere": "Raahaa luokka tänne",
		"Original": "Alkuperäinen",
		"Copy": "Kopio",
		"Draft": "Luonnos",
		"CanNotBeEmpty": "Ei voi olla tyhjä",
		"CanNotBeLongerThanXChars": "Ei voi olla pidempi kuin {0} merkkiä",
		"InputLengthLimitReached": "Olet saavuttanut {0}-merkin rajan",
		"Title": "Otsikko",
		"LastModified": "Viimeksi muokattu",
		"LastCreated": "Viimeksi luotu",
		"SortBy": "Lajittele",
		"OrderBy": "Järjestä",
		"PublicExamDescription": "Julkinen tenttikuvaus",
		"PublicExamDescriptionOptional": "Julkinen tenttikuvaus (valinnainen)",
		"ProfilePicture": "Profiilikuva",
		"AllowBlank": "Salli tyhjä kenttä",
		"AllowSpellcheckForAllStudents": "Anna kaikkien opiskelijoiden käyttää oikeinkirjoituksen tarkistusta",
		"Saved": "Tallennettu",
		"SavedHMS": "Tallennettu ({0}: {1}: {2})",
		"DraftSaved": "Luonnos tallennettu",
		"SaveAsNew": "Tallenna uutena",
		"NotVisibleToStudents": "Ei näy opiskelijoille",
		"YourOwnNotes": "Muistiinpanosi (valinnainen)",
		"CopyLastQuestion": "Kopioi viimeinen kysymys",
		"MaxLengthsWords": "Enimmäispituus (sanoja)",
		"LimitAnswerLength": "Rajoita vastauspituus",
		"NoLimit": "Ei rajoitusta",
		"SoftLimit": "Pehmeä raja",
		"HardLimit": "Kova raja",
		"MaxPoints": "Enimmäispisteet",
		"GradingInformation": "Arviointitiedot",
		"Subject": "Aihe",
		"TakePartInAClass": "Osallistu luokkaan",
		"EnterCodeTeacherProvided": "Syötä tentin järjestäjän antama koodi",
		"EnterCode": "Syötä koodi",
		"TakePartInClass": "Osallistu luokkaan",
		"YouAreTryingToEnterThisClass": "Yrität osallistua tähän luokkaan",
		"TypeInYourStudentCodeFor": "Anna opiskelijakoodi",
		"AndConfirmYourChoice": "ja vahvista valintasi",
		"Accept": "Hyväksy",
		"FaultyCode": "Virheellinen koodi.",
		"RemindMeLater": "Muistuta minua myöhemmin",
		"RegistrationIsClosed": "Rekisteröinti on suljettu.",
		"UploadStatus.HandedIn": "Palautettu",
		"UploadStatus.WrongExam": "Väärä tentti",
		"UploadStatus.InvalidEmail": "Virheellinen sähköposti.",
		"UploadStatus.StudentNotFound": "Tällä opiskelijalla ei ole vielä tiliä. Tilin hallitsijan tulee ensin luoda tili.",
		"ChangeLanguage": "Vaihda kieltä",
		"Language": "Kieli",
		"ChooseClass": "Valitse luokka",
		"YouHaveNoClassesOrGroupsToManage": "Sinulla ei ole hallittavia luokkia tai ryhmiä.",
		"StopExam": "Pysäytä tentti",
		"DownloadGradesSpreadsheet": "Lataa arvosanat-taulukko.",
		"DownloadGradesSpreadsheetIndicateUnanswered": "Osoita vastaamattomat kysymykset \\-\\\"\"",
		"OpenGrading": "Avaa arviointi",
		"GradeExam": "Arvostele tentti",
		"For": "Varten",
		"StartExam": "Aloita tentti",
		"Tests": "Testit",
		"FinishedExams": "Suoritetut tentit",
		"ChooseAnotherClass": "Valitse toinen luokka",
		"Locked": "Lukittu",
		"Unlocked": "Avattu",
		"Yes": "Kyllä",
		"No": "Ei",
		"NotDigitally": "Ei digitaalisesti",
		"OngoingExam": "Käynnissä oleva tentti",
		"HaveOpenedExam": "ovat avanneet tentin",
		"HaveSubmitted": "ovat palauttaneet",
		"NotStartedStudents": "Opiskelijat, jotka eivät ole aloittaneet",
		"DoYouWantToEndTheOngoingExam": "Haluatko lopettaa käynnissä olevan tentin?",
		"YesEndExam": "Kyllä, lopeta tentti",
		"DeleteExam": "Poista tentti",
		"DeleteExams": "Poista tentit",
		"DeleteTemplateExam": "Poista tenttimalli",
		"DeleteTemplateExams": "Poista tenttimallit",
		"AreYouSureToDeleteExam": "Haluatko varmasti poistaa valitun tentti?",
		"AreYouSureToDeleteExams": "Haluatko varmasti poistaa valitun tentit",
		"AreYouSureToDeleteTmpExam": "Haluatko varmasti poistaa valitun tenttimalli?",
		"AreYouSureToDeleteTmpExams": "Haluatko varmasti poistaa valitun tenttimallit?",
		"YesDelete": "Kyllä, poista",
		"NoSubmissionsForGroupExam": "Opiskelijat eivät ole tehneet tenttiä, tentin lopettaminen siirtää sen ajoitettuihin tentteihin.",
		"NoSubmissionsForIdExam": "Opiskelijat eivät ole tehneet tenttiä, lopettaessasi tentin nyt, se siirtyy arkistoon.",
		"ActiveStudents": "Aktiiviset opiskelijat",
		"OfflineStudents": "Offline-opiskelijat",
		"PenAndPaperStudents": "Kynä & paperi opiskelijat",
		"AbsentStudents": "Poissa olevat opiskelijat",
		"FilterStudents": "Suodata opiskelijat",
		"Updated": "Päivitetty",
		"UpdatedEvery20Sec": "päivittyy 20 sekunnin välein",
		"StudentInformation": "Opiskelijatiedot",
		"LockSettings": "Lukitse asetukset",
		"Actions": "Toiminnot",
		"Started": "Aloitettu",
		"LatestDataReceived": "Viimeisin data vastaanotettu",
		"TurnedIn": "Palautettu",
		"StudentStatus": "Opiskelijan tila",
		"Lockstatus": "Lukossa-status",
		"TheClassName": "Luokan nimi",
		"Create": "Luo",
		"EnterTheClassName": "Anna luokan nimi",
		"TheNameIsNotAllowed": "Nimi ei ole sallittu.",
		"TheCourseName": "Kurssin nimi",
		"EnterTheCourseName": "Anna kurssin nimi",
		"TheGroupsName": "Ryhmän nimi",
		"EnterTheGroupsName": "Anna ryhmien nimi",
		"TextQuestion": "Tekstikysymys",
		"SingleChoiceQuestion": "Monivalintakysymys",
		"MultiChoiceQuestion": "Useita vastauksia -kysymys",
		"WordGapQuestion": "Sanavälikysymys",
		"LoadDraft": "Lataa luonnos",
		"LoadDraftExplanation": "Löysimme luonnoksen \\{0}\\\", jota on viimeksi muokattu {1}, haluatko ladata luonnoksen?",
		"NoDiscardDraft": "Ei, hävitä luonnos",
		"QuestionCapDescription_Soft": "Pehmeä raja antaa opiskelijoille mahdollisuuden ylittää rajan ja varoitus näkyy, jos se ylittyy.",
		"QuestionCapDescription_Hard": "Kova raja estää opiskelijoita ylittämästä rajaa.",
		"QuestionTitle": "Kysymyksen otsikko",
		"QuestionShownToTheStudents": "Kysymys näytetään opiskelijoille",
		"QuestionNeedsAValidAnswer": "Yksi vastausvaihtoehdoista on merkattava oikeaksi.",
		"Alternative": "Vaihtoehtoinen",
		"Options": "Vaihtoehdot",
		"AddAlternative": "Lisää vaihtoehto",
		"QuestionNeedsAtLeastAValidAnswer": "Vähintään yksi vastausvaihtoehdoista on merkattava oikeaksi.",
		"Correct": "Oikea",
		"CorrectAnswer": "Oikea vastaus",
		"CorrectAlternative": "Oikea vaihtoehto",
		"IncorrectAnswer": "Väärä vastaus",
		"Scoring": "Pisteytys",
		"RemoveImage": "Poista kuva",
		"Remove": "Poista",
		"MoveUp": "Liiku ylös",
		"MoveDown": "Siirry alas",
		"Exam": "Tentti",
		"EndExam": "Lopeta tentti",
		"RemoteProctoring": "Etävalvonta",
		"RemoteProctoring.Access": "Avaa etävalvonta",
		"RemoteProctoring.Info": "Tämä painike avaa uuden välilehden ulkoiseen etävalvonnan ohjaukseen.",
		"DownloadOfflineFile": "Lataa Offline-tiedosto",
		"NoStudentsStartedTheExam": "Yksikään opiskelija ei ole aloittanut tätä tenttiä",
		"StudentsHasNotHandedInFinalAnswers": "Yksi tai useampi opiskelija ei ole palauttanut vastauksiaan.",
		"StudentsAreOfflineAndHasNotHadTheirFinalAnswersUploaded": "Yksi tai useampi opiskelija on offline-tilassa eivätkä ole palauttaneet vastauksiaan.",
		"StudentsHasNotStartedTheExam": "Yksi tai useampi opiskelija ei ole aloittanut tenttiä.",
		"Done": "Tehty",
		"EditCourse": "Muokkaa kurssia",
		"LackingPermissions": "Puuttuvat käyttöoikeudet",
		"LackingPermissionsToDoThis": "Sinulla ei näytä olevan oikeuksia tehdä tätä.",
		"Change": "Muuttaa",
		"ArchiveCourse": "Arkistoi kurssi",
		"AreYouSureYouWantToArchiveTheCourse": "Haluatko arkistoida tämän kurssin?",
		"Archive_Course_YouCanNotUndoThis": "Se siirtyy arkistoon ja voit palauttaa sen myöhemmin.",
		"Upload": "Ladata",
		"TheFileIsEmpty": "Tiedosto on tyhjä.",
		"CouldNotReadFile": "Tiedostoa ei voitu lukea virheellisen muodon takia.",
		"CouldNotRead": "Ei voitu lukea",
		"TheLine": "viiva",
		"TheLines": "viivat",
		"SomethingWentWrong": "Jotain meni pieleen.",
		"SomethingWentWrongLong": "Tapahtui virhe, yritä myöhemmin uudelleen tai ota yhteyttä tukeen.",
		"LatestDownload": "Viimeksi ladattu",
		"NotSet": "Ei valittu",
		"NotAnswered": "Ei vastattu",
		"NotGraded": "Ei arvosteltu",
		"Published": "Julkaistu",
		"NotPublished": "Ei julkaistu",
		"Published.plural": "Julkaistu",
		"NotPublished.plural": "Ei julkaistu",
		"NotHandedIn": "Ei palautettu",
		"HandedIn": "Palautettu",
		"NotHandedIn.plural": "Ei palautettu",
		"HandedIn.plural": "Palautettu",
		"CurrentExam": "Nykyinen tentti",
		"NotYetRated": "Ei vielä arvosteltu",
		"GradesLastSaved": "Arvosanat tallennettu viimeksi:",
		"TheStudent": "Opiskelija",
		"Student": "Opiskelija",
		"StudentX": "Opiskelija {0}",
		"StudentsAnswers": "Opiskelijoiden vastaukset",
		"FinalGrade": "Lopullinen tulos",
		"FinalGradesForX": "Lopulliset tulokset {0}",
		"FinalGradesFor": "Lopulliset arvosanat",
		"ResultsVisibilityWhenPublishing": "Opiskelija näkee kysymykset, vastaukset, kommentit ja arvosanat, jos julkaiset tulokset.",
		"ResultsVisibilityWhenUnpublishing": "Opiskelijat eivät enää näe kysymyksiä, vastauksia, kommentteja ja arvosanoja, jos piilotat tulokset.",
		"ThereAreStillStudentsWhoAreUnfinished": "Kaikki opiskelijat eivät vielä ole palauttaneet lopullisia vastauksiaan, haluatko varmasti julkaista tulokset?",
		"Publish.Ellipsis": "Julkaista...",
		"Unpublish.Ellipsis": "Piilota...",
		"PublishResults": "Julkaise tulokset",
		"UnpublishResults": "Piilota tulokset",
		"PublishedTheResults": "Julkaistut tulokset",
		"UnpublishedTheResults": "Julkaisemattomat tulokset",
		"FailedToPublishResults": "Tulosten julkaiseminen epäonnistui",
		"FailedToUnpublishResults": "Tulosten piilottaminen epäonnistui",
		"ResultsForX": "Tulokset {0}",
		"WordsNoCap": "Sanat, ei rajoitusta",
		"WordsSoftCap": "Sanat, pehmeä raja",
		"WordsHardCap": "Sanat, kova raja",
		"Grading": "Arviointi",
		"SearchStudent": "Etsi opiskelija",
		"FinalGradesForXHasNotBeenTurnedIn": "Lopullisia vastauksia {0} ei ole vielä palautettu, et voi arvioida opiskelijaa, ennen kuin vastaukset on palautettu.",
		"UploadOffLineFileToGradeStudent": "Lataa offline-tiedosto opiskelijan lopullisista vastauksista, jotta voit antaa arvosanan opiskelijalle.",
		"OfflineFileName": "Offline-tiedosto on nimettävä: {0}",
		"Answer": "vastaus",
		"Answer.Capitalized": "Vastaus",
		"Answer.WordCount": "Sanamäärä",
		"XAnswer": "{0} Vastaus",
		"point": "piste",
		"points": "pisteet",
		"XPoints": "{0} pistettä",
		"XOfYPoints": "{0} / {1} pistettä",
		"Points": "Pisteet",
		"Total": "Yhteensä",
		"Grade": "Arvosana",
		"Grades": "Arvosanat",
		"Grade.Verb": "Arvosana",
		"Ability": "Kyky",
		"Abilities": "Kyvyt",
		"StartGrade": "Aloita arviointi",
		"ToOverview": "Yleiskatsaus",
		"XOfYQuestionsGraded": "{0} / {1} kysymyksistä arvioitu",
		"Of": "of",
		"XOfY": "{0} / {1}",
		"AnswerShouldBeAroundXWordsLong": "Vastauksen pitäisi olla noin {0} sanaa pitkä",
		"AnswerMayNotBeLongerThanXWords": "Vastaus ei saa olla pidempi kuin {0} sanaa",
		"OnlyOneAlternativeIsCorrect": "Vain yksi vaihtoehto on oikea",
		"ManyAlternativesAreCorrect": "Yksi tai useampi vaihtoehto voi olla oikea",
		"PrintExam": "Tulosta tentti",
		"Teacher": "Tentin järjestäjä",
		"Scope_make_course": "Luo kurssi",
		"Scope_view_course": "Näytä kurssi",
		"Scope_edit_course": "Muokkaa kurssia",
		"Scope_make_exam": "Luo tentti",
		"Scope_view_exam": "Näytä tentti",
		"Scope_edit_exam": "Muokkaa tenttiä",
		"Scope_plan_exam": "Suunnittele tentti",
		"Scope_stop_exam": "Pysäytä tentti",
		"Scope_copy_exam": "Kopioi testi",
		"Scope_open_exam": "Avaa tentti",
		"Scope_run_exam": "Suorita tentti",
		"Scope_grade_exam": "Arvostele tentti",
		"Scope_view_exam_grades": "Näytä tenttien arvosanat",
		"Scope_download_exam": "Lataa tentti",
		"Scope_upload_exam": "Lataa tentti",
		"Scope_monitor_exam": "Valvo tenttiä",
		"Scope_publish_exam": "Julkaise tentti",
		"Scope_link_class": "Yhdistä luokka",
		"Scope_make_group": "Luo ryhmä",
		"Scope_link_group": "Yhdistä ryhmä",
		"Scope_view_group": "Näytä ryhmä",
		"Scope_edit_group": "Muokkaa ryhmää",
		"Scope_archive_group": "Arkistoi ryhmä",
		"Scope_pull_student": "Poista opiskelija",
		"Scope_add_student": "Lisää opiskelija",
		"Scope_make_node": "Luo merkki",
		"Scope_apply_role": "Lisää rooli",
		"Scope_make_role": "Luo rooli",
		"StartDate": "Aloituspäivämäärä",
		"StartTimeLocal": "Aloitusaika (paikallinen aika)",
		"LimitDescription": "Tentti voidaan aloittaa korkeintaan näin monen minuutin kuluttua aloitusajan jälkeen.",
		"Stop": "Lopeta päivämäärä",
		"StopDate": "Pysäytä päivämäärä",
		"StopTime": "Pysäytä aika",
		"DurationDescription": "Minuuttien määrä, joka opiskelijalla on aikaa tentin tekemiseen.",
		"OtherSettings": "Muut asetukset",
		"MaximumScore": "Maksimipisteet tälle tentille.",
		"AreYouReallySure": "Oletko varma?",
		"Elapsed": "Kulunut",
		"OverallProgress": "Kokonaisedistyminen",
		"Print.PageBreak": "Sivunvaihto",
		"Print.BlankPage": "Tyhjä sivu",
		"Print": "Tulosta",
		"PrintAttendance": "Tulosta osallistujalista",
		"PrintPaperExam": "Tulosta tentti",
		"Print.Ellipsis": "Tulosta tai lataa...",
		"DownloadPDF.One": "Lataa PDF yhtenä tiedostona",
		"DownloadPDF.Multiple": "Lataa PDF useana tiedostona",
		"PrintResults": "Tulosta tulokset",
		"PrintResults.Feedback.Error.NoStudentSelected": "Sinun on valittava vähintään yksi opiskelija, jonka vastaukset tulostetaan.",
		"PrintResults.Feedback.Error.NoQuestionSelected": "Sinun on valittava vähintään yksi tulostettava kysymys.",
		"PrintCloud.Button": "Cloud Print",
		"PrintCloud.Header": " Digiexam Cloud Print",
		"PrintCloud.Body": "Olet tulostamassa Digiexam Cloud printillä. Sähköpostit lähetetään osoitteeseen {0} 20 minuutin kuluessa",
		"PrintCloud.FileSelect": "Lataa useana tiedostona tai yhtenä tiedostona",
		"PrintCloud.FileSelect.SingleFile": "Yksi tiedosto",
		"PrintCloud.FileSelect.MultipleFiles": "Useita tiedostoja",
		"Share": "Jaa",
		"ShareGradingWork": "Jaa arviointityöt",
		"ShareGradingWork.Ellipsis": "Jaa arviointityö...",
		"ShareGradingWork.Remove": "Poista arviointiosuus",
		"ThisUserIsDeleted": "Poistettu käyttäjä",
		"XOfYFinalResultsSet": "{0} / {1} lopullisista tuloksista",
		"Loading": "Ladataan",
		"LoadingExam": "Ladataan tenttiä",
		"ContinueGrading": "Jatka arviointia",
		"HideGradedStudents": "Piilota arvioidut opiskelijat",
		"ShowGradedStudents": "Näytä arvioidut opiskelijat",
		"NextStudent": "Seuraava opiskelija",
		"PreviousStudent": "Edellinen opiskelija",
		"CantEditGradeBecausePublished": "Et voi muokata opiskelijan tuloksia, kun tentti on julkaistu. Piilota tentti ensin.",
		"XHasNotAnsweredThisQuestion": "{0} ei ole vastannut tähän kysymykseen.",
		"StudentHasNoFinalGrade": "Ei arvosteltu",
		"XHasLeftExamBlankYouCantAnswer": "{0} on jättänyt tentin tyhjäksi, et voi arvioida tyhjää tenttiä.",
		"TypeToSearch": "Kirjoita yllä olevaan kenttään etsiäksesi...",
		"NoStudentsFound": "Ei löydetty opiskelijoita.",
		"RemoveTheActiveFiltersToShowHiddenStudents": "Poista aktiiviset suodattimet piilotettujen opiskelijoiden näyttämiseksi.",
		"RemoveFilters": "Poista suodattimet",
		"All": "Kaikki",
		"Online": "Online",
		"PenAndPaper": "Kynä ja paperi",
		"Offline": "Offline",
		"Absent": "Poissa",
		"Active": "Aktiivinen",
		"YesStartExam": "Kyllä, aloita tentti",
		"DoYouWantToStartTheExam": "Haluatko aloittaa tentin {0}",
		"ExamId": "Tenttitunnus",
		"Ongoing": "Meneillään oleva",
		"NotStarted": "Ei alkanut",
		"MoveExam": "Siirrä tentti",
		"ErrorLoadingCourses": "Kurssien lataamisessa tapahtui virhe",
		"FaultMovingExamTryAgainLater": "Tenttiä siirrettäessä tapahtui virhe, kokeile myöhemmin uudelleen tai yhteyttä tukeen.",
		"ChooseWhichClassToMoveExam": "Valitse mille luokalle haluat siirtää tentin.",
		"YouNeedToSetATitle": "Sinun täytyy asettaa otsikko.",
		"ThereIsAlreadyARubricWithThatTitle": "Tällä samalla otsikolla on jo pisteytysopas.",
		"YouNeedToSetASubject": "Sinun täytyy asettaa aihe.",
		"YouNeedToAddQuestions": "Sinun on lisättävä kysymyksiä.",
		"AQuestionNeedsATitle": "Kysymys tarvitsee otsikon.",
		"AQuestionNeedsText": "Kysymys tarvitsee tekstiä.",
		"AMOrSQuestionNeedsAlternatives": "Monivalinta tai single choice kysymyksessä vaaditaan vastausvaihtoehtoja.",
		"AQuestionAlternativeNeedsATitle": "Kysymysvaihtoehto tarvitsee otsikon.",
		"AMOrSQuestionNeedsCorrectAlternative": "Monivalinta tai single choice kysymys tarvitsee oikean vaihtoehdon.",
		"AQuestionHasAnInvalidCap": "Kysymyksellä on virheellinen sanarajoitus.",
		"AQuestionNeedsAMaxScore": "Kysymys tarvitsee enimmäispisteet.",
		"Search": "Hae",
		"QuestionNotGraded": "Kysymystä ei ole arvosteltu.",
		"TeachersComment": "Tentin järjestäjän kommentti",
		"ObtainedScore": "Saadut pisteet",
		"TextOnlyQuestion": "Otsikko",
		"TextOnlyAboutPlaceholder": "Otsikko kuvaus (valinnainen)",
		"Abbreviation": "Lyhenne",
		"UpdateInformation": "Päivitä tieto",
		"ChangeCover": "Vaihda kansi",
		"ChangeProfilePhotoOrCover": "Kuvat organisaatiolle",
		"Incorrect": "väärä",
		"NotUploaded": "Ei ladattu",
		"Uploaded": "Ladattu",
		"Uploading": "Lataa",
		"UploadFailed": "Lataus epäonnistui",
		"DoYouWantToShareX": "Haluatko jakaa '% V'?",
		"EnterTheEmailAdressYouWantToShareWith": "Anna henkilön sähköpostiosoite, jonka kanssa haluat jakaa '%v'",
		"ExampleEmail": "example@example.com",
		"Organization": "Organisaatio",
		"Organization.Edit": "Muokkaa {0}",
		"AllOrganizations": "Kaikki organisaatiot",
		"AllOrganizationTypes": "Kaikki organisaatiotyypit",
		"UnspecifiedQualityStatus": "Määrittelemätön laatutila",
		"Created": "Luotu",
		"Freemium": "Freemium",
		"NonFreemium": "Ei-freemium",
		"FeatureRemoteProctoringEnabled": "Ominaisuus: Etävalvonta",
		"LoggingYouIn": "Kirjaudutaan sisään",
		"LoggingIn": "Kirjaudutaan sisään",
		"Statistics": "Tilastot",
		"Roles": "Roolit",
		"RolesAndUsers": "Roolit ja käyttäjät",
		"Permissions": "Oikeudet",
		"NumberOfUsers": "Käyttäjien lukumäärä",
		"NoRolesAddedAddRole": "Ei lisätty rooleja. Lisää rooli.",
		"AddRole": "Lisää rooli",
		"PendingInvites": "Odottavat kutsut.",
		"NoPendingInvites": "Ei odottavia kutsuja.",
		"InviteUsers": "Kutsu käyttäjiä",
		"Revoke": "Kumoa",
		"ALinkWillBeSentToThisUserInvite": "Näille käyttäjille lähetetään linkki, jonka kautta he voivat hyväksyä kutsun. Kutsun hyväksyttyään he voivat käyttää olemassa olevaa tiliä tai luoda uuden.",
		"Role": "Rooli",
		"ToInvite": "Kutsu",
		"TheRoleXHasBeenCreated": "Rooli \"{0}\" on luotu.",
		"TheRoleXHasBeenDeleted": "Rooli \"{0}\" on poistettu.",
		"TheNodeYouTriedToVisitDoesntExist": "Organisaatiota, jossa yritit käydä, ei ole olemassa.",
		"Teachers": "Opettajat",
		"Exams": common.exams,
		"ExamTemplates": common.examTemplates,
		"TheInviteToXHasBeenSent": "Kutsu \"{0}\" on lähetetty.",
		"TheInvitesToXPeopleBeenSent": "Kutsut {0} henkilöille on lähetetty.",
		"FailedToSendInvite": "Kutsun lähettäminen epäonnistui: {0}",
		"FailedToSendInvites": "Kutsujen lähettäminen epäonnistui: {0}",
		"YouNowHaveTheRoleOfXAtX": "Sinulla on nyt rooli {0} {1}",
		"InvalidInviteError": "Kutsu, jota yritit käyttää ei ole voimassa.",
		"InvalidActivationLinkError": "Käyttämäsi aktivointilinkki ei ole voimassa.",
		"Resend": "Lähetä uudelleen",
		"UsersWithRole": "Käyttäjät, joilla on rooli",
		"ChangeProfileImage": "Vaihda profiilikuva",
		"UploadImage.FailedX": "Kuvan lataaminen epäonnistui: {0}",
		"EditInformation": "Muokkaa tietoja",
		"DoYouWantToRemoveTheRole": "Haluatko poistaa roolin?",
		"DoYouWantToRemoveTheRoleX": "Haluatko poistaa roolin {0}",
		"DoYouWantToRevokeTheRole": "Haluatko peruuttaa roolin?",
		"DoYouWantToRevokeTheRoleForX": "Haluatko peruuttaa roolin {0}?",
		"RevokedRoleXFromX": "Peruutettu rooli {0} alkaen {1}.",
		"CouldNotRevokeRoleXFromX": "Ei voinut peruuttaa roolia {0} {1}.",
		"RoleIsExternallyManaged": "Roolia johdetaan ulkoisesti ja perutaan ainoastaan Digiexamissa, ei pääkäyttöjärjestelmässä.",
		"ResentTheInviteToX": "Kutsu lähetetty uudelleen {0}.",
		"CouldNotResendTheInviteToX": "Kutsua ei voitu lähettää uudelleen {0}.",
		"DoYouWantToRemoveTheInvite": "Haluatko poistaa kutsun?",
		"DoYouWantToRemoveTheInviteToX": "Haluatko poistaa kutsun {0}?",
		"RemovedTheInviteToX": "Kutsu poistettiin {0}.",
		"CouldNotRemoveTheInviteToX": "Ei voitu poistaa kutsua {0}.",
		"TheOrganizationXHasBeenCreated": "Organisaatio {0} on luotu.",
		"Organizations": "Järjestöt",
		"CreateOrganization": "Luo organisaatio",
		"ParentOrganizationId": "Isäntäjärjestön tunnus",
		"CouldNotCreateTheOrganizationX": "Organisaatiota {0} ei voitu luoda.",
		"CouldNotRemoveExamX": "Tenttiä \\{0}\\\".\" ei voitu poistaa",
		"RemovedExamX": "Poistettiin tentti \\ {0} \\ \".\"",
		"AnonymizeExam": "Anonymisoi tentti",
		"AnonymizeExam.Ellipsis": "Anonymisoi tentti...",
		"DeAnonymize": "Poista anonymisointi",
		"DeAnonymize.Ellipsis": "Poista anonymisointi ...",
		"AnonymizeExplanation": "Tentin muuttaminen anonyymiksi piilottaa opiskelijoiden nimet ja muut tiedot kaikilta, jotka arvostelevat, tulostavat tentin tai lataavilta sen arvosanataulukon.",
		"DeAnonymizeExplanation": " Jos poistat tentin anonymisoinnin, oppilaiden nimet ja tiedot näkyvät kaikille, jotka arvioivat tai tulostavat kokeen tai lataavat arvosanataulukon.",
		"RoleType_0": "PUB",
		"RoleType_1": "Opiskelija",
		"RoleType_2": "Tentin järjestäjä",
		"RoleType_4": "Järjestelmänvalvoja",
		"RoleType_8": "Pääkäyttäjä",
		"RoleType_16": "Tilin haltija",
		"RoleType_32": "Valvoja",
		"ShareTheResults": "Jaa tulokset",
		"YouSharedXWithY": "Jaoit  \\{0}\\\" {1}\" kanssa",
		"CouldNotShareCantHandleExams": "Ei voitu jakaa tenttiä, koska tämä käyttäjä ei voi käsitellä tenttejä.",
		"CouldNotShareCantHandleRubrics": "Ei voitu jakaa pisteytysopasta, koska tämä käyttäjä ei voi käsitellä pisteytysoppaita.",
		"CouldNotShareExamNoEmailX": "Ei voitu jakaa tenttiä, koska käyttäjää sähköpostilla \\{0}\\\"\" ei ole olemassa.",
		"CouldNotShareExamCantGrade": "Ei voitu jakaa tenttiä, koska käyttäjä \\{0}\\\" ei voi arvioida tenttejä.",
		"CouldNotShareGradingOwner": "Ei voinut jakaa luokittelua, koska \\ {0} \\ \"on tämän tentin omistaja\"",
		"FailedToShareExam": "Tentin jakaminen epäonnistui.",
		"FailedToShareRubric": "Pisteytysoppaan jakaminen epäonnistui.",
		"NameOrStudentCode": "Nimi tai opiskelijakoodi",
		"Previous": "Edellinen",
		"Next": "Seuraava",
		"NoExamsFound": "Tenttejä ei löytynyt",
		"ShowQuestionDetails": "Näytä kysymystiedot",
		"HideQuestionDetails": "Piilota kysymystiedot",
		"Images": "Kuvat",
		"Image": "Kuva",
		"ColorRed": "Punainen",
		"ColorBlue": "Sininen",
		"ColorAqua": "Turkoosi",
		"ColorPink": "Vaaleanpunainen",
		"ColorGreen": "Vihreä",
		"ColorYellow": "Keltainen",
		"Color": "Väri",
		"Comment": "Kommentti",
		"AnnotationSummary": "Yhteenveto merkinnöistä",
		"TeachersAnnotations": "Opettajan merkinnät",
		"TeachersAnnotations.Tooltip.Text": "Taustagrafiikkaa käytetään tulostusasetuksissa näyttämään merkintöjen korostusvärit.",
		"Delete": "Poista",
		"Deleted": "Poistettu",
		"OnePerLine": "Yksi per rivi",
		"UserIsDisabled": "Käyttäjä on poistettu käytöstä",
		"ContactDigiExamForMoreInformation": "Ota yhteyttä Digiexamiin.",
		"ServerRespondedWith": "Palvelin vastasi: {0}",
		"ShowMore": "Näytä lisää",
		"ShowLess": "Näytä vähemmän",
		"MustBeANumber": "On oltava numero",
		"CantBeHigherThanX": "Ei voi olla suurempi kuin {0}",
		"CantBeLowerThanX": "Ei voi olla pienempi kuin {0}",
		"Rubric": "Pisteytysopas",
		"Rubrics": common.rubrics,
		"RemoveGrade": "Poista arvosana",
		"RemoveAbility": "Poista kyky",
		"WarningWhenRemovingRubricGrade": "Tämän arvosanan poistaminen poistaa myös kaikki arvosanaan liittyvät kriteerit.",
		"WarningWhenRemovingRubricAbility": "Tämän kyvyn poistaminen poistaa myös kaikki kykyyn liittyvät kriteerit.",
		"AddGrade": "Lisää arvosana",
		"AddAbility": "Lisää kyky",
		"ClickToEdit": "Klikkaa muokataksesi",
		"Criteria": "Kriteeri",
		"Criterion": "Kriteeri",
		"Description": "Kuvaus",
		"AssessmentType": "Arviointityyppi",
		"ScoreBasedGrading": "Pisteisiin perustuva arviointi.",
		"ScoreBasedGrading.Description": "Tentti on pisteisiin perustuva.",
		"ScoreBasedGrading.Info1": "Asettaa pisteet kullekin kysymykselle ja lopullisen arvosanan tentille. Monivalinta-kysymykset arvioidaan automaattisesti.",
		"RubricBasedAssessment": "Pisteytysoppaaseen pohjautuva arviointi",
		"RubricBasedAssessment.Description": "Tentti arvioidaan pisteytysoppaaseen pohjautuen. \\t",
		"RubricBasedAssessment.Info1": "Käytä pisteytysopasta yksityiskohtaisempaan tapaan arvioida oppilaiden suorituksia eri taitojen tai kriteerien puitteissa.",
		"DropARubricHereToUseItInTheExam": "Pudota tähän pisteytysopas käyttääksesi sitä tentissä.",
		"View": "Näkymä",
		"RubricRequiredToSelectQuestionAbilities": "Sinun on lisättävä tenttiin pisteytysopas, ennen kuin voit valita kyvyt tähän kysymykseen.",
		"AbilitiesToMeasure": "Kyky mitata",
		"AnsweringAlternatives": "Vastausvaihtoehdot",
		"RemovingRubricFromExamWarning": "Jotkut tentin kysymykset on määritetty mitattavaksi kyvyillä. Jos poistat pisteytysoppaan, myös tämä rakenne poistetaan. Haluatko varmasti poistaa pisteytysoppaan \\{0}\\\"?\"",
		"GradeNameIsRequired": "Arvosanan nimi on pakollinen",
		"AbilityNameIsRequired": "Kyvyn nimi vaaditaan",
		"NamelessGrade": "Nimetön arvosana",
		"YouNeedToAddGrades": "Sinun täytyy lisätä arvosanoja",
		"YouNeedToAddAbilities": "Sinun täytyy lisätä kykyjä",
		"ResultSummary": "Tulosten yhteenveto",
		"SummarizedAssessment": "Arvioinnin yhteenveto",
		"ShowRubric": "Näytä pisteytysopas",
		"PublishedResults": "Julkaistut tulokset",
		"TheResultsArePublished": "Tulokset julkaistaan",
		"ShowWhichPartsCanBeSeenByTheStudents": "Näytä, mitkä osat opiskelijat näkevät",
		"StudentsResults": "Opiskelijoiden tulokset",
		"ShowIfAlternativeIsCorrect": "Näytä, jos vaihtoehto on oikea",
		"Score": "Pisteet",
		"RightToLeft.Long": "Tekstisuunta: Oikealta vasemmalle",
		"RightToLeft.Long.Info1": "Ota tämä asetus käyttöön kielille, jotka ovat oikealta vasemmalle, esim. persia, arabia ja heprea.",
		"LockedQuestionSequence.Title": "Lukittu kysymysjärjestys (MEQ)",
		"LockedQuestionSequence.Disclaimer": "Kysymysten otsikot ovat edelleen näkyvillä. ",
		"LockedQuestionSequence.Info": "Kysymysten järjestys on lukittu tentissä. Opiskelija ei voi palata muokkaamaan vastauksiaan.",
		"FindStudents": "Etsi opiskelijoita",
		"StudentName": "Opiskelijan nimi",
		"StudentSearch.Placeholder": "Nimi, opiskelijakoodi tai sähköposti",
		"StudentSearch.Placeholder.CodeDisabled": "Nimi tai sähköposti",
		"StudentSearch.TooManyResults": "Kokeile pidempää hakutermiä kaventamaan tuloksia",
		"StudentSearch.FilterTooltip": "Voit suodattaa tuloksia tuloksia sen perusteella, mitkä pääsyoikeudet opiskelijalle on myönnetty. Siirrä hiiri kohtaan \\Pääsyoikeudet\\\" ja valitse minkä asetusten perusteella haluat suodattaa.\"",
		"StudentSearch.ShowAll": "Näytä kaikki",
		"StudentSearch.ShowAllByEmailCode": "Näytä kaikki (sähköpostiosoitteella opiskelijakoodina)",
		"StudentSearch.Unauthorized": "Freemium-kouluilla ei ole oikeuksia opiskelijoiden hallinnointiin. Ota yhteyttä myyntiin koulusi päivittämiseksi.",
		"StudentSearchUnavailable": "Ei voi etsiä opiskelijoita tällä hetkellä, yritä uudelleen tai ota yhteyttä Digiexam-tukeen.",
		"AccountCreated": "Tili luotu",
		"StudentAt": "Opiskelija",
		"NoClassesFound": "Luokkia ei löytynyt",
		"ViewResult": "Näytä tulos",
		"ViewClass": "Näytä luokka",
		"StudentHasNotParticipatedInAnyExams": "Opiskelija ei ole osallistunut mihinkään tentteihin, joihin sinulla on pääsy.",
		"StudentDoesNotBelongToAnyClass": "Opiskelija ei kuulu mihinkään luokkaan, johon sinulla on pääsy.",
		"StudentNotFound": "Ei löytynyt opiskelijaa, jolla on id {0}",
		"Exam.OnlyYourExamsShown": "Vain sinun tenttisi näytetään.",
		"Class.OnlyYourClassesShown": "Vain sinun luokkasi näytetään.",
		"RubricUsedInExam": "Tätä pisteytysopasta on käytetty kokeessa. Arvosanoja ja kykyjä ei voi enää muuttaa.",
		"SaveAsNewCopyRubric": "Valitse TALLENNA UUTENA luodaksesi kopion tästä pisteytysoppaasta.",
		"SetANewTitle": "Aseta uusi otsikko.",
		"Fullscreen": "Koko näyttö",
		"ExitFullscreen": "Poistu koko näytön-tilasta.",
		"SalesCRMId": "Pipedrive ID",
		"Search.ShowingXofYMatches": "Näytetään {0} / {1} yhteensopivista",
		"TeachersFeedback": "Opettajan palaute",
		"TeachersFeedback.Long": "Opettajan palaute opiskelijalle",
		"TeachersFinalFeedback.Long": "Opettajan lopullinen palaute opiskelijalle",
		"Publish.Publish.LongTitle": "Julkaise tulokset niin, että opiskelijat näkevät ne",
		"Publish.Publish.PartDescription": "Valitse osat, joiden pitäisi näkyä opiskelijoille.",
		"Publish.Published.LongTitle": "Julkaistut tulokset, jotka opiskelijat ovat nähneet",
		"Publish.Published.PartDescription.ExamOwnerOrAdmin": "Valitut osat näkyvät opiskelijoille, voit muuttaa, mitkä osat opiskelijat voivat nähdä.",
		"Publish.Published.PartDescription.NotExamOwnerOrAdmin": "Valitut osat näkyvät opiskelijoille. Ainoastaan tentin omistaja voi muuttaa sitä, mitkä osat näkyvät opiskelijoille.",
		"Publish.Unpublish.LongTitle": "Piilota tulokset, jotka opiskelijat ovat nähneet.",
		"Publish.Unpublish.PartDescription": "Valitut osat näkyvät opiskelijoille.",
		"Publish.StudentDescription": "Opiskelijat näkevät vain omat vastauksensa.",
		"ShareGrading.LongTitle": "Jaa arviointi toisen opettajan kanssa.",
		"ShareGrading.Description": "Valitse kysymykset ja opiskelijat, jotka haluat sallia opettajan arvostella.",
		"ShareGrading.EmailLabel": "Jaettavan opettajan sähköpostiosoite",
		"ShareGrading.Error.EmailMissing": "Sinun on annettava opettajan sähköpostiosoite, jonka kanssa haluat jakaa arvioinnin.",
		"ShareGrading.Error.NoQuestionsSelected": "Sinun on valittava vähintään yksi kysymys jaettavaksi.",
		"ShareGrading.Error.NoStudentSelected": "Sinun on valittava vähintään yksi opiskelija jaettavaksi.",
		"Student.StudentCode.Notification.AlreadyAdded.Class": "Opiskelijakoodi on jo luokassa.",
		"Student.StudentCode.Error.MinLength": "Opiskelijakoodin on oltava vähintään 1 merkin pituinen.",
		"Student.StudentCode.Error.MaxLength": "Opiskelijakoodi ei saa ylittää 50 merkkiä",
		"Student.StudentCode.Error.Chars": "Opiskelijakoodi saa sisältää vain merkkejä a-Z 0-9 - . @ _",
		"Student.Name.Error.MinLength": "Nimen on oltava vähintään 2 merkkiä",
		"Student.Name.Error.MaxLength": "Nimen on oltava enintään 500 merkkiä",
		"Student.New": "Uusi oppilas",
		"Student.ChangeStudentCode.Title": "Vaihda Opiskelijakoodi",
		"Student.ChangeStudentCode.Description": "Tätä työkalua käytetään opiskelijakoodien joukkomuutokseen.",
		"Student.ChangeStudentCode.Excel": "Liitä excelistä muodossa: sähköposti, opiskelijakoodi",
		"Student.ChangeStudentCode.WontApply": "Opiskelijakoodin muutokset, joita ei oteta käyttöön",
		"Student.ChangeStudentCode.WillApply": "Opiskelijakoodin muutokset käyttöön",
		"Student.ChangeStudentCode.Perform": "Suorita koodien vaihto",
		"Student.ChangeStudentCode.Verify": "Tarkista koodien muutokset",
		"Student.ChangeStudentCode.TooManySelected": "Koodia ei voi muuttaa enempää kuin {0} oppilaalle kerralla",
		"Student.ChangeStudentCode.Success.Single": "Oppilaan koodin vaihto onnistui",
		"Student.ChangeStudentCode.Success": "{0} oppilaan koodia muutettiin",
		"Student.ChangeStudentCode.Progress": "Muutetaan koodia {0} opiskelijalle",
		"Student.ChangeStudentCode.Failure": "Seuraavia opiskelijoita ei voitu muuttaa:",
		"Student.Delete": "Poista opiskelijat",
		"Student.Notification.AlreadyAdded.Class": "{0} jo luokassa",
		"Student.Notification.Error": "Tapahtui virhe, {0} ei voitu lisätä",
		"Student.Notification.DoesNotExist.Single": "Organisaatiossa ei ole opiskelijaa sähköpostiosoitteella",
		"Student.Notification.DoesNotExist.Multiple": "Opiskelijaa ei ole organisaatiossa",
		"Student.Notification.NotAdded": "Opiskelijaa ei lisätty",
		"Student.Delete.Progress": "Poistetaan {0} opiskelijat",
		"Student.Delete.Explanation": "Vain opiskelijat, jotka eivät ole vielä aloittaneet eivätkä ole yhdistetty tenttiin, voidaan poistaa.",
		"Student.Delete.Others": "ja {0} muut ...",
		"Student.Delete.Success.Single": "Opiskelija poistettiin onnistuneesti",
		"Student.Delete.Success": "{0} opiskelijat poistettiin onnistuneesti",
		"Student.Delete.Failure": "Seuraavia opiskelijoita ei voitu poistaa:",
		"Student.Delete.Button": "Poista {0} opiskelijat",
		"Student.Delete.Button.Single": "Poista {0} opiskelija",
		"Student.Delete.TooManySelected": "Ei voi poistaa enemmän kuin {0} opiskelijoita kerralla",
		"Feedback.Saving.Ellipsis": "Tallennetaan...",
		"Feedback.Saved": "Tallennettu",
		"Feedback.Saved.1:Time": "Tallennettu {0}",
		"Feedback.AutoSaved.1:Time": "Tallennettu automaattisesti {0}",
		"Feedback.DraftSaved": "Luonnos tallennettu",
		"Feedback.DraftSaved.1:Time": "Luonnos tallennettu {0}",
		"Feedback.ErrorSaving": "Tallennus epäonnistui",
		"Feedback.FailedToShareExam": "Tentin jakaminen epäonnistui",
		"Feedback.CouldNotRemoveShare": "Ei voitu poistaa jakoa",
		"Feedback.Added.Entity": "{0} on lisätty luokkaan",
		"Feedback.Added.Single.Student": "Lisätty 1 opiskelija",
		"Feedback.Added.Count.Students": "Lisätty {0} opiskelijaa",
		"Feedback.ErrorArchiving": "Arkistointi epäonnistui",
		"Feedback.ErrorDeleting": "Poistaminen epäonnistui",
		"Feedback.SuccessArchived": "Arkistoitu onnistuneesti!",
		"Feedback.SuccessDeleted": "Poistettu onnistuneesti!",
		"Entity.Created.By": "{0}",
		"Shared.By": "Jaettu {0}",
		"Exam.State.0": "Tyhjä",
		"Exam.State.1": "Luonnos",
		"Exam.State.2": "Palautettu",
		"Exam.State.3": "Tyhjä",
		"Exam.Parts": "Osat",
		"Action.Continue": "Jatka",
		"Action.Restore": "Palauta",
		"Action.Delete": "Poista",
		"Action.DeleteSelected": "Poista valitut",
		"Action.SelectAll": "Valitse kaikki",
		"Action.DeselectAll": "Poista valinnat kaikista",
		"Action.AddStudent": "Lisää opiskelija",
		"Action.AddStudentToClass": "Lisää opiskelija luokkaan",
		"Action.AddStudentWithEmail": "Lisää opiskelija sähköpostiosoitteella",
		"Action.AddStudent.Plural": "Lisää useita opiskelijoita",
		"Action.SelectRubric": "Valitse pisteytysopas",
		"Action.CannotBeUndone": "Tätä toimintaa ei voi peruuttaa",
		"State.Deleted": "Poistettu",
		"State.Archived": "Arkistoitu",
		"State.TeachersFeedback.Missing": "Opettaja ei ole kirjoittanut palautetta",
		"State.FinalGrade.Missing": "Opettaja ei ole määrittänyt lopullista tulosta",
		"ForgotPassword.Fail.EmailNotFound": "Tällä sähköpostiosoitteella ei löytynyt tiliä.",
		"ForgotPassword.Fail.InvalidToken": "Linkissä oli virhe",
		"ForgotPassword.Fail.ExpiredToken": "Tämä linkki on vanhentunut",
		"ForgotPassword.Fail.LinkUsed": "Tämä linkki on jo käytetty",
		"ForgotPassword.Fail.SendNewLink": "Lähetä uusi linkki painamalla painiketta.",
		"ForgotPassword.Fail.SendNewLinkButton": "Lähetä uusi linkki",
		"AcceptInvite.RoleDescription": "Olet kutsuttu {0} {1}.",
		"AcceptInvite.HowToAccept.Part1": "Luo tili hyväksyäksesi kutsun.",
		"AcceptInvite.HowToAccept.Part2": " Jos sinulla on jo Digiexam-tili.",
		"AcceptInvite.AcceptDescription": "Hyväksy rooli {0} {1}.",
		"AcceptInvite.InvalidInvite": "Emme voineet avata kutsua. Yritä uudelleen tai ota yhteyttä henkilöön, joka lähetti kutsun sinulle.",
		"PasteFrom.InvalidEmail": "Sähköposti rivillä {0} ei kelpaa: {1}",
		"PasteFrom.Duplicate": "Sähköpostiosoite rivillä {0} on kaksoiskappale: {1}, sama sähköpostiosoite saa olla listalla ainoastaan kerran.",
		"PasteFrom.DoesNotExist": "Ei voinut lisätä opiskelijoita luokkiin, yksi tai useampi opiskelija ei ole olemassa organisaatiossa",
		"PasteFrom.InvalidColumnCount.SingularExpected": "Rivillä {0} pitäisi olla {1} sarake, mutta sillä on {2}: {3}",
		"PasteFrom.InvalidColumnCount.PluralExpected": "Rivillä  {0} pitäisi olla {1} saraketta, mutta sillä on {2}: {3}",
		"PasteFrom.SomethingWentWrong": "Tapahtui virhe, yritä myöhemmin uudelleen tai ota yhteyttä tukeen.",
		"AddStudentsToClass": "Lisää opiskelijat luokkaan",
		"PasteFromSpreadsheet.Title": "Liitä laskentataulukosta",
		"PasteFromSpreadsheet.Description": "Voit lisätä useita opiskelijoita luokkaan kopioimalla ja liittämällä taulukosta.",
		"PasteFromSpreadsheet.FormatDescription": "Taulukossa pitää olla sarake, jossa on opiskelijoiden sähköpostiosoitteet.",
		"PasteFromSpreadsheet.ForMoreInformation": "Lisätietoja varten, lue seuraava ohje:",
		"PasteFromSpreadsheet.HelpLink.Title": "Opiskelijoiden lisääminen luokkaan",
		"PasteFromSpreadsheet.HelpLink.Url": "https://digiexam.zendesk.com/hc/en-us/Articles/202559711-add-students-to-class-by-pasting-From-excel",
		"GettingStartedGuide.DoNotShowAgain": "Älä näytä tätä opasta uudelleen",
		"GettingStartedGuide.CreateYourExam": "Luo ensimmäinen tenttisi",
		"GettingStartedGuide.slide1.Heading": "Tervetuloa",
		"MonitorExamInfo.Title": "Saumaton arviointi ja valvonta",
		"MonitorExamInfo.Text1": "Seuraa opiskelijoiden edistymistä helpommin",
		"MonitorExamInfo.Text2": "Palaa nopeasti kokeenäkymään arvioinnista",
		"GettingStartedGuide.slide1.Text1": "Esittelemme sinulle Digiexam-alustan muutamalla yksinkertaisella askeleella.",
		"GettingStartedGuide.slide1.Text2": "Aloitetaan",
		"GettingStartedGuide.slide2.Heading": "Luo tentti",
		"GettingStartedGuide.slide2.Text1": "Luodaksesi tentin tarvitset otsikon, aiheen ja vähintään yhden kysymyksen. Voit helposti luoda sellaisen tentin kuin haluat. Joitakin vaihtoehtoja:",
		"GettingStartedGuide.slide2.Item1": "Pisteisiin tai pisteytysoppaaseen perustuva arviointi.",
		"GettingStartedGuide.slide2.Item2": "Anna opiskelijoiden käyttää oikeinkirjoituksen tarkistusta",
		"GettingStartedGuide.slide2.Item3": "Tenttien tekeminen anonyymeiksi",
		"GettingStartedGuide.slide3.Heading": "Aloita tai aikatauluta",
		"GettingStartedGuide.slide3.Text1": "Voit aloittaa tentin välittömästi tai aikatauluttaa sen myöhemmäksi.",
		"GettingStartedGuide.slide4.Heading": "Tenttitunnus tai ryhmä",
		"GettingStartedGuide.slide4.Text1": "Sinulla on kaksi vaihtoehtoa opiskelijoiden tenttiin pääsyn myöntämiseksi.",
		"GettingStartedGuide.slide4.Text2": "Tenttitunnus",
		"GettingStartedGuide.slide4.Text3": "Ryhmä",
		"GettingStartedGuide.slide4.Item1": "Ainutlaatuinen tenttitunnus luodaan, kun tentti aloitetaan.",
		"GettingStartedGuide.slide4.Item2": "Kuka tahansa opiskelija voi aloittaa tentin tenttitunnuksella.",
		"GettingStartedGuide.slide4.Item3": "Opiskelijoita ei tarvitse lisätä etukäteen",
		"GettingStartedGuide.slide4.Item4": "Vain valitussa listassa olevat opiskelijat voivat tehdä tentin",
		"GettingStartedGuide.slide4.Item5": "Kopioi ja liitä opiskelijaluettelot Excelistä",
		"GettingStartedGuide.slide4.Item6": "Tentti on automaattisesti käytettävissä luettelossa oleville opiskelijoille",
		"GettingStartedGuide.slide5.Heading": "Tee tentti",
		"GettingStartedGuide.slide5.Text1": "Nyt opiskelijoidesi on aika tehdä tentti! Ensin heidän täytyy ladata Digiexam-sovellus Windows, Mac, Chromebook tai iPad -laitteelleen.",
		"GettingStartedGuide.slide5.Text2": "Opiskelijat pääsevät tenttiin tenttitunnuksella (avoimet tentit) tai käyttämällä samoja opiskelijatietoja, jotka on lisätty luokkaan (suunnitellut tentit).",
		"GettingStartedGuide.slide5.tip": "Kun opiskelijat aloittavat tentin, Digiexam-sovellus lukitsee näytön, jotta he eivät voi tehdä mitään muuta tentin aikana.",
		"GettingStartedGuide.slide6.Heading": "Arvioi tentti",
		"GettingStartedGuide.slide6.Text1": "Voit antaa opiskelijoille yksityiskohtaista palautetta heidän vastauksistaan. On todella helppoa kommentoida ja korostaa tiettyjä osia opiskelijan vastauksesta.",
		"GettingStartedGuide.slide6.Item1": "Arvioi tentti per kysymys tai per opiskelija",
		"GettingStartedGuide.slide6.Item2": "Automaattinen arvostelu pisteisiin perustuville monivalintakysymyksille",
		"GettingStartedGuide.slide6.Item3": "Ei enää lukukelvotonta käsialaa",
		"GettingStartedGuide.slide6.tip": "Voit jakaa arviointityön kollegoidesi kanssa. Yhteistyö ei ole koskaan ollut helmpompaa!",
		"GettingStartedGuide.slide7.Heading": "Julkaise tentti",
		"GettingStartedGuide.slide7.Text1": "Kun olet arvioinut tentin, voit julkaista tulokset ja opiskelijat voivat kirjautua sisään tulokset nähdäkseen.",
		"GettingStartedGuide.slide7.Text2": "Voit valita, mitkä tentin osat julkaistaan. Esimerkiksi, voit julkaista tuloksia, mutta et kysymyksiä ja vastauksia ennen kuin kaikki opiskelijat ovat tehneet tentin",
		"GettingStartedGuide.slide7.tip": "Voit julkaista ja piilottaa tenttituloksia milloin tahansa haluat.",
		"NodeType.Title": "Organisaatiotyyppi",
		"NodeType.0": "Ei määritelty",
		"NodeType.1": "Sisäinen",
		"NodeType.2": "Korkeampi koulutus",
		"NodeType.3": "Toisen asteen koulutus",
		"NodeType.4": "Ensisijainen koulutus",
		"NodeType.5": "Koulutusyritys",
		"QualityStatus.Title": "Laatu status",
		"QualityStatus.0": "Ei vahvistettu",
		"QualityStatus.1": "Vahvistettu",
		"QualityStatus.2": "Roska",
		"AbilityOverview.Title": "Kyvyt",
		"AbilityOverview.Description": "Valitse pisteytysopas nähdäksesi kuinka opiskelija on suoriutunut sen mittaamissa kyvyissä.",
		"AbilityOverview.NoItems": "Nähdäkseen suorituskyvyn yksilöllisissä kyvyissä opiskelijalla on tehtynä ainakin yksi tentti, joka arvostellaan pisteytysopasta käyttäen.",
		"Student.None": "Ei opiskelijoita",
		"Student.Singular": "Opiskelija",
		"Student.Plural": "Opiskelijat",
		"SyncToLMS.Title": "Oppimisen hallintajärjestelmä (LMS)",
		"SyncToLMS.Published": "Lähetä opiskelijoiden julkaistut arvosanat ja palaute LMS: lle.",
		"Notifications.Title": "Ilmoitukset",
		"Notifications.Published": "Ilmoita opiskelijoille sähköpostilla, että tenttitulokset on julkaistu.",
		"ExamStarts": "Tentti alkaa",
		"ExamEnded": "Tentti päättyi",
		"Month.1": "tammikuu",
		"Month.2": "helmikuu",
		"Month.3": "maaliskuu",
		"Month.4": "huhtikuu",
		"Month.5": "toukokuu",
		"Month.6": "kesäkuu",
		"Month.7": "heinäkuu",
		"Month.8": "elokuu",
		"Month.9": "syyskuu",
		"Month.10": "lokakuu",
		"Month.11": "marraskuu",
		"Month.12": "joulukuu",
		"YourComputerLocalTime": "Tietokoneesi paikallinen aika on",
		"MoreOnHowYouUploadAnswerFiles": "Lisää siitä, miten voit ladata offline-vastaustiedostoja",
		"Accessibility": "Esteettömyys",
		"AccessibilitySettings": "Esteettömyysasetukset",
		"AllowSpellcheckForStudent": "Salli oikeinkirjoituksen tarkistus tälle opiskelijalle",
		"City": "Kaupunki",
		"State": "Osavaltio",
		"Country": "Maa",
		"YouHaveNotAddedRubricToExam.Saving": "Tähän tenttiin ei ole liitetty pisteytysopasta.",
		"AbilitiesHaveNotBeenSelectedForAllQuestions.Saving": "Mitattavia kykyjä ei ole valittu kaikkiin kysymyksiin.",
		"MergeSelectedOrganizations": "Yhdistä valitut organisaatiot",
		"MergeSelectedOrganizations.Description": "Tätä työkalua käytetään organisaatioiden yhdistämiseen.",
		"MergeSelectedOrganizations.SelectedOrganizations": "Valitut organisaatiot yhdistyvät:",
		"MergeSelectedOrganizations.MergeTo": "Valitse yhdistettävä organisaatio:",
		"MergeSelectedOrganizations.Errors": "Ei voi yhdistää seuraavien virheiden takia:",
		"MergeSelectedOrganizations.OrgIdErrors": "Organisaatio on maksava asiakas:",
		"MergeSelectedOrganizations.mergeCheck.button": "Yhdistyksen tarkistus",
		"MergeSelectedOrganizations.mergePossible.status": "Organisaation yhdistyminen on mahdollista.",
		"MergeSelectedOrganizations.mergePayingPossible.status": "Organisaation yhdistyminen on mahdollista. Mutta tavoite on maksava asiakas.",
		"MergeSelectedOrganizations.mergePossible.button": "Yhdistä",
		"MergeSelectedOrganizations.mergeDone.status": "Organisaatioiden yhdistäminen aloitettu. Saat sähköpostitse ilmoituksen, kun organisaatiot on yhdistetty.",
		"OrgId": "Organisaation tunnus",
		"ResetLTICredentials": "Nollaa LTI-tunnistetiedot",
		"EnableLTIIntegration": "Ota LTI-integraatio käyttöön",
		"DisableLTIIntegration": "Poista LTI-integraatio käytöstä",
		"Integrations": "Integraatiot",
		"LTIIntegration": "LTI-integraatio",
		"LTIIntegration.MoreInfo": "Lue lisää LTI-integroinnista",
		"Jobs": "Työpaikat",
		"Jobs.Id": "Työn tunnus",
		"Jobs.Details": "Työn tiedot",
		"Jobs.StartedBy": "Aloitti:",
		"Jobs.Successful": "Onnistunut:",
		"Jobs.Skipped": "Ohittanut:",
		"Jobs.StudentImport": "Opiskelijan tuonti",
		"Jobs.Status.Created": "Luotu",
		"Jobs.Status.Running": "Käynnissä oleva",
		"Jobs.Status.Done": "Tehty",
		"Jobs.Status.Error": "Virhe: Virheellinen tila",
		"Jobs.ClearSearch": "Tyhjennä haku",
		"AccountManagerImports": "Tuonti",
		"AccountManagerImports.Title": "Tuo tiedot",
		"AccountManagerImports.Id": "Tuo tunnus",
		"AccountManagerImports.NotFound": "Tuontia ei löytynyt",
		"AccountManagerImports.ImportStudents": "Tuo opiskelijat",
		"AccountManagerImports.ImportingStudents": "Ladataan tuonteja...",
		"AccountManagerImports.ImportCounter": "{0} / {1} opiskelijoista tuotu",
		"AccountManagerImports.Imported": "Tuotu:",
		"AccountManagerImports.ImportedStudents": "Tuodut opiskelijat:",
		"AccountManagerImports.DeletedStudents": "Opiskelija tunnus {0} on poistettu",
		"AccountManagerImports.DeletedStudents.Internal": "Digiexamin henkilökunta on poistanut opiskelijan {0}",
		"AccountManagerImports.AccessibilitySettings": "Esteettömyysasetukset",
		"AccountManagerImports.Errors": "Virheet:",
		"AccountManagerImports.UnableToImport": "Ei voi tuoda ({0})",
		"AccountManagerImports.SuccessfullyImported": "Tuodut opiskelijatiedot ({0})",
		"AccountManagerImports.LoadError": "Tuontitietoja ei voitu ladata",
		"AccountManagerImports.LoadError.Student": "Tuontitietoja ei voitu ladata opiskelijasta {0}",
		"AccountManagerImports.Duplicate.Title": "Opiskelija on jo olemassa {0}",
		"AccountManagerImports.Duplicate.Message": "Käyttäjällä {0} on jo opiskelija {1}.",
		"AccountManagerImports.Duplicate.LoadError": "Tuontivirheitä ei voitu ladata",
		"AccountManagerImports.Placeholder.PasteStudents": "Liitä opiskelijatiedot tänne",
		"AccountManagerImports.SelectOrganizationInfo": "Valitse organisaatio",
		"AccountManagerImports.UserId": "käyttäjätunnus",
		"AccountManagerImports.Status": "Tila",
		"AccountManagerImports.Created": "Luotu",
		"AccountManagerImports.Option.Any": "Mikä tahansa",
		"AccountManagerImports.Error.SomethingWentWrong": "Tapahtui virhe, yritä myöhemmin uudelleen tai ota yhteyttä tukeen.",
		"Node.Setting.StudentCode": "Käytä opiskelijakoodeja",
		"Node.Setting.StudentCode.MoreInfo": "Opiskelijakoodit ovat valinnaisia ​​ja ne voidaan poistaa käytöstä, jos niitä ei tarvita. Jos opiskelijakoodit ovat poissa käytöstä, ne eivät näy Digiexamissa, eikä niitä vaadita opiskelijoiden luomisessa.",
		"Integrations.SAML": "SAML-integraatio",
		"Integrations.SAML.Enable": "Ota SAML-integraatio käyttöön",
		"Integrations.SAML.Disable": "Poista SAML-integraatio käytöstä",
		"Integrations.SAML.Skolfederation": "Skolfederation",
		"Integrations.SAML.Other": "Muu ",
		"Ingegrations.SAML.Upload": "Lataa",
		"Integrations.SAML.Save": "Tallenna",
		"Integrations.SAML.Remove": "Poista identiteetin tarjoaja",
		"Integrations.SAML.UnitId": "Yksikkökoodi",
		"Integrations.SAML.FileUpload.1": "Lataa Identity Provider (IDP) metatieto XML-tiedosto.",
		"Integrations.SAML.FileUpload.2": "Pudota tiedosto mihin tahansa sivulla tai klikkaa tätä ruutua.",
		"Integrations.SAML.SkolfederationSelect": "Skolfederation Identity Provider (IDP)",
		"Integrations.SAML.ValidUntil": "Voimassa kunnes",
		"Integrations.SAML.Error.403": "Tapahtui virhe: Puuttuva lupa.",
		"Integrations.SAML.IDPAlreadyInUse": "IDP tällä tunnuksella on jo käytössä toisessa organisaatiossa",
		"Integrations.SAML.Error.Unhandled": "Tapahtui tuntematon virhe.",
		"Integrations.SAML.MoreInfo": "Lue lisää SAML-integraatiosta",
		"Integrations.Skolon": "Skolon integraatio",
		"Integrations.Skolon.Enable": "Ota Skolonin integraatio käyttöön",
		"Integrations.Skolon.Disable": "Poista Skolonin integraatio käytöstä",
		"Ingegrations.Skolon.Save": "Tallenna",
		"Integrations.Skolon.SkolonId": "Skolon-tunnus",
		"Integrations.Skolon.WrongRegExp": "Skolon-tunnus voi sisältää vain aakkosnumeerisia merkkejä",
		"Integrations.Skolon.TooShort": "Skolon-tunnuksen on oltava 50 merkkiä",
		"Integrations.Skolon.SaveSuccess": "Skolon-tunnus tallennettu onnistuneesti",
		"Integrations.Skolon.SaveError": "Virhe Skolon-tunnuksen tallennuksen aikana",
		"Integrations.Skolon.SaveConflict": "Skolon-tunnus on jo toisen organisaation käytössä",
		"Integrations.Skolon.MoreInfo": "Lue lisää Skolon-integraatiosta",
		"ExternalTools": "Ulkoiset työkalut",
		"ExternalTools.New": "Uusi ulkoinen työkalu",
		"ExternalTools.Create": "Luo ulkoinen työkalu",
		"ExternalTools.TitleAdd": "Lisää ulkoinen työkalu",
		"ExternalTools.MyTool": "Työkaluni",
		"ExternalTools.Existing": "Olemassa olevat ulkoiset työkalut",
		"ExternalTools.Edit": "Muokkaa ulkoista työkalua",
		"ExternalTools.Delete": "Poista ulkoinen työkalu",
		"ExternalTools.LandingPage": "Aloitussivu",
		"ExternalTools.LandingPageURL": "Aloitussivu URL",
		"ExternalTools.WholeDomain": "Koko verkkotunnus",
		"ExternalTools.SingleWebPage": "Yksittäinen verkkosivu",
		"ExternalTools.PartOfDomain": "Osa verkkotunnusta",
		"ExternalTools.AllowLists": "Sallittujen luettelo",
		"ExternalTools.AllowDomains": "Salli koko verkkotunnukset",
		"ExternalTools.AllowSinglePages": "Salli yksittäiset verkkosivut",
		"ExternalTools.AllowPartialDomainAccess": "Salli osittainen pääsy verkkotunnuksiin",
		"ExternalTools.AddURL": "Lisää URL-osoite",
		"ExternalTools.InvalidURL": "Syötetty web-osoite ei ole kelvollinen",
		"ExternalTools.InvalidURLFormat": "Syötetyllä web-osoitteella ei ole kelvollista muotoa",
		"ExternalTools.URLCouldNotBeReached": "Syötetty Web-osoitetta ei voitu saavuttaa",
		"ExternalTools.URLAlreadyExists": "Syötetty Web-osoite on jo luettelossa",
		"ExternalTools.InvalidLandingPage": "Aloitussivu ei ole voimassa",
		"ExternalTools.InvalidLandingPageFormat": "Aloitussivulla ei ole voimassa olevaa muotoa",
		"ExternalTools.LandingPageCouldNotBeReached": "Aloitussivua ei voitu saavuttaa",
		"ExternalTools.StudentEquipmentChecks": "Opiskelijoiden varusteiden tarkastukset",
		"ExternalTools.Camera": "Kamera",
		"ExternalTools.Microphone": "Mikrofoni",
		"ExternalTools.ScreenShare": "Näytön jako",
		"ExternalTools.CanEditEquipment": "Opettaja voi asettaa/muokata oppilaiden laitteita",
		"ExternalTools.CanEditLandingPage": "Opettaja voi asettaa / muokata aloitussivua",
		"ExternalTools.ChangeIcon": "Vaihda kuvake",
		"ExternalTools.Tooltip.New": "Ulkoiset työkalut ovat ominaisuus, joka mahdollistaa erilaisten verkkosovellusten ja verkkosivujen käyttämisen tentteihin, joita ei voi käyttää online-resurssien ominaisuuden kanssa. Esimerkiksi ominaisuus tukee verkkosivustoja tai web-sovelluksia, jotka edellyttävät käyttäjää kirjautumaan.",
		"ExternalTools.Tooltip.Name": "Ulkoisen työkalun nimi, joka näkyy opiskelijalle Digiexam clientissa tenttiä tehdessä.",
		"ExternalTools.Tooltip.LandingPageURL": "Kun tätä ulkoista työkalua käytetään tentissä, tämä on ensimmäinen sivu, jonka opiskelija näkee.",
		"ExternalTools.Tooltip.CanEditLandingPage.P1": "Tämän asetuksen aktivointi antaa opettajalle mahdollisuuden muokata tilinhaltijan asettamaa aloitussivua.",
		"ExternalTools.Tooltip.CanEditLandingPage.P2": "Tilinhaltija voi myös jättää aloitussivun tyhjäksi, kun tämä asetus on aktivoitu. Kuitenkin, jos aloitussivu jätetään tyhjäksi, opettajan on pakollista lisätä aloitussivu, kun ulkoista työkalua käytetään tenttimiseen.",
		"ExternalTools.Tooltip.AllowLists.P1.title": "Salli yksittäiset verkkosivut",
		"ExternalTools.Tooltip.AllowLists.P1.body": "Antaa opiskelijan selata vain lisättyjen verkkosivujen sisältöä",
		"ExternalTools.Tooltip.AllowLists.P2.title": "Salli koko verkkotunnukset",
		"ExternalTools.Tooltip.AllowLists.P2.body": "Antaa opiskelijan selata ja navigoida vapaasti määritellyillä verkkotunnuksilla ilman rajoitteita.",
		"ExternalTools.Tooltip.AllowLists.P3.title": "Salli osittainen pääsy verkkotunnuksiin",
		"ExternalTools.Tooltip.AllowLists.P3.body": "Sallii osallistujan selata valittua verkkosivustoa ilman rajoituksia. On mahdollista selata kyseisen verkkosivun alasivuja, mutta ei ole mahdollista siirtyä mainitusta verkko-osoitteesta ylemmälle tasolle. ",
		"ExternalTools.Tooltip.AllowList.LandingPage": "Tämä on aloitussivu, se lisätään aina yhdeksi verkkosivuksi.",
		"ExternalTools.Tooltip.StudentEquipmentChecks": "Aktivoi laitteiden tarkastukset käytettäessä ulkoisia työkaluja, kuten videoneuvotteluja tai kokoustyökaluja, jotka edellyttävät opiskelijan laitteiden kuten kameran ja/tai mikrofonin käyttöä. Tämä kehottaa opiskelijan käyttämää käyttöjärjestelmää antamaan Digiexamille luvan aktivoitujen laitteiden käyttöön.",
		"ExternalTools.InternetWarning": "Opiskelijan on oltava yhdistettynä Internetiin käyttääkseen ulkoista työkalua.",
		"ExternalTools.DeleteWarning.Title": "Haluatko varmasti poistaa {0}?",
		"ExternalTools.DeleteWarning.Body.UsedInTemplates": "Tätä ulkoista työkalua käytetään {0} tenttipohjissa. Se tulee edelleen olemaan saatavilla aktiivissa ja päättyneissä tenteissä, joissa se on käytössä.",
		"ExternalTools.DeleteWarning.Body.NotUsedInTemplates": "Kun tämä ulkoinen työkalu on poistettu, se on edelleen saatavilla aktiivisissa ja päättyneissä kokeissa, joissa se on käytössä.",
		"ExternalTools.SuccessfullyAddedInfo": "Ulkoinen työkalu lisättiin onnistuneesti",
		"ExternalTools.SuccessfullySavedInfo": "Ulkoinen työkalu tallennettiin onnistuneesti",
		"ExternalTools.SuccessfullyDeletedInfo": "Ulkoinen työkalu {0} poistettiin onnistuneesti",
		"ExternalTools.SuccessfullyAddedUrl": "URL {0} lisättiin onnistuneesti",
		"ExternalTools.SuccessfullyAddedLandingPageUrl": "Aloitussivu URL {0} lisättiin onnistuneesti",
		"ExternalTools.CouldNotSaveError": "Muutoksia ei voitu tallentaa",
		"ExternalTools.CouldNotLoadError": "Ulkoista työkalua ei voitu ladata",
		"ExternalTools.CouldNotLoadError.Plural": "Ulkoisia työkaluja ei voitu ladata",
		"ExternalTools.CouldNotDeleteError": "Ulkoista työkalua {0} ei voitu poistaa",
		"ExternalTools.EnterNameError": "Anna työkalun nimi tallentaaksesi",
		"ExternalTools.NameTooLongError": "Työkalun nimi ei saa olla pidempi kuin {0} merkkiä",
		"ExternalTools.EnterLandingPageError": "Anna aloitussivun URL-osoite tallentaaksesi",
		"ExternalTools.SetIcon": "Aseta kuvake {0}",
		"ExternalTools.SomeDeletedWarning.Title": "Jotkin ulkoiset työkalut on poistettu",
		"ExternalTools.SomeDeletedWarning.Body": "Seuraavat ulkoiset työkalut on poistettu: <strong> {0} </ strong>. Niitä ei voi enää käyttää tulevissa tenteissä.",
		"ExternalTools.SomeDeletedWarning.OnExamStart": "Seuraavat ulkoiset työkalut on poistettu: <strong> {0} </ strong>. Ne eivät ole saatavilla tässä tentissä.",
		"ExternalToolSettings.EnterLandingPageError": "Sinun on asetettava aloitussivu ulkoiselle työkalulle \\{0}\\\".\" ",
		"ExternallyManaged": "Ulkoisesti hallinnoitu",
		"ExternallyManagedExplanation": "Tätä roolia hallinnoidaan toisessa järjestelmässä Digiexamin ulkopuolella. Sinun on käytettävä toista järjestelmää roolin muuttamiseksi ja nämä muutokset näkyvät Digiexamissa seuraavan kerran, kun kirjaudut Digiexamiin tämän järjestelmän kautta.",
		"OnlyExternallyManagedRolesExist": "Tällä organisaatiolla on rooleja, joita hallitaan toisessa järjestelmässä Digiexamin ulkopuolella, mutta ei rooleja, joita Digiexam hallitsee. Et voi kutsua käyttäjiä ulkoisesti hallinnoituihin rooleihin Digiexamista käsin.",
		"PrintSettings.Heading": "Tulostusasetukset",
		"PrintSettings.HeadingClose": "Sulje tulostusasetukset",
		"PrintSettings.PageBreaks.Title": "Sivunvaihdot",
		"PrintSettings.PageBreaks.Disabled": "Ei sivunvaihtoja",
		"PrintSettings.PageBreaks.ExamTitle": "Otsikon jälkeen",
		"PrintSettings.PageBreaks.Student": "Ennen jokaista opiskelijaa",
		"PrintSettings.PageBreaks.Question": "Ennen jokaista kysymystä",
		"PrintSettings.DoubleLineSpacing.Title": "Kaksoisväli",
		"PrintSettings.DoubleLineSpacing.Description": "Näytä tyhjä rivi jokaisen tekstirivin jälkeen.",
		"PrintSettings.AddBlankPage": "Erottele tyhjällä sivulla",
		"PrintSettings.SortBy.Students": "Opiskelijat",
		"PrintSettings.SortBy.Questions": "Kysymykset",
		"PrintSettings.ExcludeUnansweredQuestions.Title": "Jätä pois vastaamattomat kysymykset",
		"PrintSettings.HideStudentNames.Title": "Piilota opiskelijoiden nimet",
		"PrintSettings.HideStudentNames.Description": "Kun opiskelijoiden nimet on piilotettu, opiskelijat järjestellään uudelleen opiskelijakoodin perusteella.",
		"PrintSettings.NameSettings.Title": "Nimiasetukset",
		"PrintSettings.NameSettings.body1": "Ainakin yksi vaihtoehto on valittava.",
		"PrintSettings.NameSettings.body2": "Jos valitaan useita vaihtoehtoja, ne seuraavat järjestyksessä:",
		"PrintError.Heading": "Tulostusvirhe",
		"PrintError.Info": "Asiakirjaa haettaessa tapahtui virhe.",
		"EditClassName": "Muokkaa luokan nimeä",
		"EnterNewClassName": "Anna uusi luokan nimi",
		"NewClassName": "Uusi nimi",
		"Referral.ReferFriends": "Suosittele ystäviä ja kollegoja",
		"Referral.ReferFriendsMotivation": "Kutsu ystäviä ja työtovereita rekisteröitymään Digiexamiin ja kokemaan mahtavat edut!",
		"Referral.ShareLink": "Voit myös kutsua jakamalla linkin:",
		"Referral.EmailsSendSuccessful": "Sähköpostit ovat matkalla! Kiitos Digiexamin suosittelusta!",
		"Referral.EmailsSendError": "Sähköpostiviestejä ei lähetetty teknisen virheen vuoksi. Yritä uudelleen. Jos ongelma jatkuu, ota yhteyttä tukeen.",
		"Referral.MustBeValidEmail": "Oltava voimassa oleva sähköpostiosoite",
		"Referral.AtLeastOneEmailInvalid": "Ainakin yksi sähköpostiosoitteista ei ole voimassa. Korjaa virheellinen sähköpostiosoite ennen lähettämistä.",
		"Referral.EnterAtLeastOneEmail": "Anna vähintään yksi sähköpostiosoite ennen lähettämistä.",
		"RandomizeTheOrderOfQuestions": "Satunnaista kysymysten järjestys.",
		"RandomizeTheOrderOfAlternatives": "Satunnaista vaihtoehtojen järjestys.",
		"OpenBookExam": "Avoin kirja -tentti",
		"AnonymousExam": "Anonyymi tentti",
		"StudentComputerLockdown": "Opiskelijatietokoneen lukitus",
		"StudentComputerLockdown.Description.On": "Opiskelijat eivät voi surffata verkossa tai käyttää muita sovelluksia tentin aikana.",
		"StudentComputerLockdown.Description.Off": "Opiskelija voi surffata verkossa ja käyttää muita sovelluksia tentin aikana.",
		"StudentComputerLockdown.Help": "Opiskelijat voivat surffata verkossa ja käyttää muita sovelluksia tietokoneessa tentin aikana.",
		"StudentComputerLockdown.Info1": "Opiskelijatietokoneen lukitustilassa oppilaita estetään surffaamasta verkossa tai käyttämästä muita tietokoneen sovelluksia kokeen aikana.",
		"StudentComputerLockdown.Info2": "Ota käyttöön virallisia kokeita varten.",
		"StudentComputerLockdown.Info3": "Kytke pois päältä, jos opiskelijat suorittavat avoimen kirjan koetta tai työskentelevät tehtävän parissa, jota varten he voivat surffata verkossa ja käyttää muita sovelluksia.",
		"RemoteProctoringEnabled": "Etävalvonta",
		"RemoteProctoringEnabled.Info1": "Sallii sinun, etävalvojien ja järjestelmänvalvojien pääsyn opiskeljoiden web-kameroihin, mikrofoneihin ja näyttöihin käynnissä olevan tentin aikana sekä oikeuden tarkastella tallenteita tentin päättymisen jälkeen.",
		"RemoteProctoringEnabled.Description": "Opiskelijoiden tomintaa seurataan ja nauhoitetaan tenttiprosessin aikana.",
		"AllowExternalPaste": "Salli tekstin kopioiminen ja liittäminen kokeessa",
		"AllowExternalPaste.Info1": "Ota käyttöön, jotta oppilaat voivat kopioida ja liittää tekstiä vastauksiinsa. Lukitustilassa vain kokeessa olevaa tekstiä (Julkinen kokeen kuvaus, Kysymykset ja sallitut web-linkit) voidaan käyttää.",
		"General": "Yleinen",
		"ExamSettings": "Tenttiasetukset",
		"ExamSettingsInfo.Title": "Tälle tentille valitut asetukset",
		"ExamSettingsInfo.AnonymousExam.Title": "Anonyymi tentti",
		"ExamSettingsInfo.AnonymousExam.Info1": "Oppilaiden nimet eivät näy opettajille arvioinnin aikana. Kokeen aloittava käyttäjä voi poistaa anonymisoinnin, kun tentti arvostellaan.",
		"ExamSettingsInfo.AnonymousExam.Info2": "Tukeaksesi kokeita, joissa anonyymi arviointi on pakollinen, koe tulee aloittaa kokeen ylläpitäjän roolista.",
		"ExamSettingsInfo.AnonymousExam.Description": "Oppilaiden nimet eivät näy opettajille arvioinnin aikana.",
		"ExamSettingsInfo.DurationSetting.Title": "Aikarajoitettu tentti",
		"ExamSettingsInfo.DurationSetting.Description": "Opiskelijoiden on palautettava {0} tuntia ja {0} minuuttia tentin aloittamisen jälkeen.",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Title": "Oikeinkirjoituksen tarkistus sallittu",
		"ExamSettingsInfo.SpellcheckAllowedForAllStudents.Description": "Kaikki opiskelijat voivat käyttää oikeinkirjoituksen tarkastusta tentin aikana.",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Title": "Oikeinkirjoituksen tarkistus tarvittaessa",
		"ExamSettingsInfo.SpellcheckAllowedForSelectedStudents.Description": "Valitut opiskelijat voivat käyttää oikeinkirjoituksen tarkastusta tentin aikana.",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Title": "Tekstistä puheeksi sallitaan",
		"ExamSettingsInfo.TextToSpeechAllowedForAllStudents.Description": "Kaikki opiskelijat voivat käyttää tekstistä puheeksi tentin aikana.",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Title": "Tekstistä puheeksi tarvittaessa",
		"ExamSettingsInfo.TextToSpeechAllowedForSelectedStudents.Description": "Valitut opiskelijat saavat käyttää tekstistä puheeksi tentin aikana.",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Title": "USB-äänentoisto sallittu",
		"ExamSettingsInfo.UsbAudioAllowedForAllStudents.Description": "Kaikki opiskelijat voivat toistaa äänitiedostoja asetetusta USB: stä tentin aikana.",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Title": "USB-äänentoisto tarvittaessa",
		"ExamSettingsInfo.UsbAudioAllowedForSelectedStudents.Description": "Valitut opiskelijat voivat toistaa äänitiedostoja asetetusta USB:stä tentin aikana.",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Title": "Näytönlukuohjelma sallittu",
		"ExamSettingsInfo.ImmersiveReaderAllowedForAllStudents.Description": "Kaikki opiskelijat voivat käyttää näytönlukuohjelmaa.",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Title": "Näytönlukuohjelma sallittu tarvittaessa",
		"ExamSettingsInfo.ImmersiveReaderForSelectedStudents.Description": "Valitut opiskelijat voivat käyttää näytönlukuohjelmaa.",
		"ExamSettingsInfo.randomizedQuestions.Title": "Satunnainen kysymysjärjestys",
		"ExamSettingsInfo.randomizedQuestions.Description": "Kokeen aikana opiskelijoille näytettävien kysymysten järjestys on satunnaistettu.",
		"ExamSettingsInfo.randomizedQuestions.Info1": "Kokeen aikana opiskelijoille näytettävien kysymysten järjestys on satunnaistettu. Järjestys palautetaan, kun arvostelet tentin.",
		"ExamSettingsInfo.randomizedAlternatives.Title": "Satunnaista vaihtoehtojen järjestys",
		"ExamSettingsInfo.randomizedAlternatives.Description": "Kunkin kysymyksen vaihtoehtojen järjestys on satunnaistettu.",
		"ExamSettingsInfo.randomizedAlternatives.Info1": "Kunkin kysymyksen vaihtoehtojen järjestys on satunnaistettu. Järjestys palautetaan, kun arvostelet tentin.",
		"ExamSettingsInfo.lockedQuestionSequence.Title": "Lukittu kysymysjärjestys (MEQ)",
		"ExamSettingsInfo.lockedQuestionSequence.Description": "Kysymysjärjestys on lukittu kokeessa. Opiskelija ei voi palata vastattuun kysymykseen muokatakseen vastaustaan.",
		"ExamSettingsInfo.ExternalTools.Title": "Ulkoiset työkalut käytössä",
		"ExamSettingsInfo.AllowExternalPaste.Title": "Salli tekstin kopioiminen ja liittäminen kokeessa",
		"ExamSettingsInfo.AllowExternalPaste.Info.On": "Opiskelijat voivat kopioida ja liittää tekstiä koekysymyksistä ja ulkoisista resursseista vastauksiinsa",
		"ExamSettingsInfo.AllowExternalPaste.Info.Off": "Opiskelijat eivät voi kopioida/liitä tekstiä koekysymyksistä ja ulkoisista resursseista vastauksiinsa",

		"On": "Päällä",
		"Off": "Pois päältä",
		"ReadMore": "Lue lisää",

		"Support.HowToUseDigiExam": "Kuinka käyttää Digiexamia",
		"Support.WeHaveUserGuides": "Opettajille, opiskelijoille ja järjestelmänvalvojille on saatavilla käyttöoppaita Digiexamin käyttöön. Löydät myös muita asiakirjoja, kuten järjestelmävaatimuksia ja asennusoppaita.",
		"Support.GoToKnowledgeCenter": "Siirry tietokeskukseen",
		"Support.DownloadClient": "Lataa sovellus",
		"Support.AsAStudentYouNeed": "Opiskelijana sinun on ladattava ja asennettava asiakasohjelma, jotta voit tehdä tentin. Jos olet opettaja, voit ladata sovelluksen testataksesi koetta opiskelijan näkökulmasta.",
		"Support.GoToInstallationGuides": "Siirry asennusoppaisiin",
		"Support.ContactUs": "Ota meihin yhteyttä",
		"Support.NeedMoreHelp.ChatWithUs": "Chattaa kanssamme: Löydät chat-kuplan sivun oikeasta alakulmasta. (Jos et näe tätä, kokeile tyhjentää selaimesi välimuisti).",
		"Support.NeedMoreHelp.EmailUs": "Lähetä meille sähköpostia: Voit tavoittaa meidät osoitteesta <a href='{0}'>{1}</a>",
		"Support.ThisSupportFeatureIsOnly": "Tämä tukiominaisuus on vain maksavien asiakkaiden käytettävissä. Ota yhteyttä myyntitiimiimme saadaksesi lisätietoja osoitteessa <a href='{0}'>{1}</a>",
		"Support.SalesMailSubject": "Basicista Premiumiin",
		"Support.SalesMailBody": "Hei!\\n\\nOlkaa yhteydessä minuun Digiexamin hintatietoihin liittyen.\\n\\nName: \\nPhone number: \\nSchool: \\nRole:",
		"Support.OrCheckOut1": "tai katso",
		"Support.OrCheckOut2": "tai meidän",
		"Support.DigiExamIntro": "Digiexamin intro",
		"Support.PinInfo": "Tätä PIN-koodia käytetään henkilöllisyytesi vahvistamiseen, kun otat meihin yhteyttä. Se päivitetään kerran päivässä.",
		"Support.Error": "Tuki-chat on tällä hetkellä alhaalla, yritä uudelleen tai ota yhteyttä tukeen sähköpostitse: {0}",
		"Support.ContactAccountManager.Title": "Tilin haltijat",
		"Support.ContactAccountManager.Content": "Halutko luoda opiskelijoita, kutsua käyttäjiä tai puuttuuko jokin rooli? Ota yhteyttä koulusi/organisaatiosi tilin haltijoihin.",
		"Support.ContactAccountManager.Empty": "Koulussa / organisaatiossasi ei ole tilinpäälliköitä.",
		"Support.ContactAdmin.Title": "Järjestelmänvalvojat",
		"Support.ContactAdmin.Content": "Haluatko poistaa anonymisoinnin kokeesta? Ota yhteyttä koulusi/organisaatiosi järjestelmänvalvojaan.",
		"Support.ContactAdmin.Empty": "Koulussa / organisaatiossasi ei ole järjestelmänvalvojia.",
		"LTI.CouldNotSendAllGrades": "Ei voitu lähettää kaikkia arvosanoja",
		"LTI.WeEncounteredProblems": "Valitettavasti kohtasimme ongelmia lähetettäessä arvosanoja opetusalustallesi. Seuraavien opiskelijoiden arvosanoja ei voitu lähettää, ja suosittelemme, että kirjoitat heidän arvosanansa manuaalisesti opetusalustalle.",
		"LTI.SelectedExam": "Valittu tentti",
		"LTI.FillInInYourLMS": "Lisää tämä LMS-tehtävään",
		"Course.LMSManaged.title": "Digiexam toimii LMS: n kanssa",
		"Course.LMSManaged.paragraph.1": "Oppimisen hallintajärjestelmän (LMS) kurssit näkyvät täällä, kun olet käyttänyt digiexam tenttejä.",
		"Course.LMSManaged.paragraph.2": "Valitse kurssi löytääksesi käyttämäsi tentit ja oppilaat, jotka ovat rekisteröityneet tentteihin.",
		"Course.SkolonManaged.title": "Digiexam integroituu Skolonin kanssa",
		"Course.SkolonManaged.paragraph.1": "Skolon-ryhmäsi ja opiskelijasi synkronoidaan Digiexamiin Skolonista, kun kirjaudut sisään. Voit käyttää näitä ryhmiä kokeiden aloittamiseen.",
		"Course.SkolonManaged.paragraph.2": "Ryhmien muutokset (kuten opiskelijoiden tai opettajien lisääminen) on tehtävä Skolonissa, jotta voit vaikuttaa digiexamiin, kun kirjaudut uudelleen.",
		"Info": "Info",
		"NoExamSelected": "Koetta ei ole valittu",
		"ToSelectAnExam": "Valitaksesi tentin",
		"GotToSettingsForThisAssignmentInLMS": "Siirry tämän tehtävän asetuksiin oppimisen hallintajärjestelmässä",
		"ChooseDigiExamAsTheExternalTool": "Valitse ulkoiseksi työkaluksi Digiexam",
		"ChooseAnExamFromYourExamLibraryInDigiExam": "Valitse tentti kirjastosta Digiexamissa",
		"YouHaveNotStartedThisExamYet": "Et ole vielä aloittanut tätä tenttiä",
		"TipDoNotSetStartAndEndDatesInLMS": "Vinkki! Älä aseta aloitus- ja lopetuspäiviä oppimisen hallintajärjestälmässäsi.",
		"TipDoNotSetStartAndEndDatesInLMS.Info": "Jos jätät aloitus- ja lopetuspäivät tyhjiksi oppimisen hallintajärjestelmässäsi, opiskelijat voivat rekisteröityä kokeeseen LMS-tilien kautta ja saada pääsyn kirjautumistietoihinsa ennen kokeen aloittamista. He näkevät myös arvosanat ja palautteen, kun tentti on valmis ja olet julkaissut tulokset.",
		"YouNeedToEndTheExamInDigiExam": "Sinun täytyy päättää tentti Digiexamissa",
		"ViewExamInDigiExam": "Näytä tentti Digiexamissa",
		"GradeExamInDigiExam": "Arvostele tentti Digiexamissa",
		"ResultsPublishedTo": "Tulokset julkaistu Digiexamista",
		"WaitForYourTeacherToAddAnExam": "Odota opettajaasi lisäämään tentin...",
		"LearnMoreAboutTakingAnExamInDigiExam": "Lisätietoja tentin tekemistä Digiexamissa",
		"IsOpenForRegistration": "on avoinna rekisteröitymistä varten",
		"RegisterMe": "Rekisteröi minut",
		"WhenYouHaveRegistered.Info": "Kun olet rekisteröitynyt, saat pääsyn kirjautumistietoihisi, joita tarvitset kokeen aloittamiseksi Digiexamissa.",
		"UnableToRegister": "Rekisteröinti epäonnistui",
		"UnableToRegister.Info": "Emme pystyneet rekisteröimään sinua tähän tenttiin.",
		"YouHaveRegisteredFor": "Olet rekisteröitynyt",
		"YourTeacherWillLetYouKnow.Info": "Opettajasi ilmoittaa sinulle, milloin tämä tentti alkaa. Kun se on alkanut, avaa Digiexam-sovellus ja anna kirjautumistietosi:",
		"DontHaveTheClient": "Eikö sinulla ole sovellusta?",
		"DownloadItHere": "Lataa se täältä",
		"YouHaveStarted": "Olet aloittanut",
		"ToContinueWritingTheExam.info": "Jatkaaksesi tentin tekoa, avaa Digiexam-sovellus. Opettajasi saattaa täytyä avata tentti sinulle.",
		"YouHaveHandedInYourAnswersFor": "Olet palauttanut vastauksesi",
		"CheckBackHereLater.Info": "Tarkista tästä myöhemmin arvosana ja opettajasi antama palaute.",
		"HasEnded": "on päättynyt",
		"FeedbackFromYourTeacher": "Palaute opettajalta",
		"SeeMoreDetailedFeedbackOnYourDigiExamAccount": "Katso lisää yksityiskohtaista palautetta Digiexam-tililläsi.",
		"GoToDigiExam": "Siirry Digiexamiin",
		"ExamAccessRestrictedToOwner": "Vain omistajalla on pääsy tähän tenttiin Digiexamissa",
		"StartNow": "Aloita nyt",
		"Move": "Siirry ryhmään",
		"MenuItem.Groups": "Ryhmät",
		"MenuItem.Rubrics": "Pisteytysoppaat",
		"MenuItem.RolesAndUsers": "Roolit ja käyttäjät",
		"AddSelectedQuestions": "Lisää valitut kysymykset",
		"Overview.CreateExam": "+ Luo uusi tentti",
		"StudentsAbsentOrUsedPenAndPaper": "Poissa tai käyttänyt kynää & paperia",
		"Update": "Päivitä",
		"WebLinks": "nettilinkit",
		"WebLink": "nettilinkki",
		"Region.Title": "Alue",
		"Region.ChangeRegion": "muuta",
		"Region.ChooseRegion": "Valitse alue",
		"Region.Europe": "Eurooppa",
		"Region.USA": "USA",
		"Region.Other": "Muut",
		"Region.Development": "Dev",
		"Login.UserWrongRegionPopupTitle": "Tilisi kuuluu toiseen alueeseen",
		"Login.UserWrongRegionPopupBody": "Näyttää siltä, ​​että tilisi on tällä hetkellä rekisteröity palvelimiin {0}, joten muutimme alueen sinulle. Yritä kirjautua sisään uudelleen.",
		"Login.TryAgain": "Yritä uudelleen",
		"Login.Europe": "Eurooppa",
		"Exams.Exams": "Tentit",
		"Exams.CreateExam": "+ Luo uusi tentti",
		"Exams.Archive": "Arkisto",
		"Exams.ImportedExam": "Tuotu tentti",
		"Exams.SharedExam": "Jaettu tentti",
		"Exams.SharedExamNotice": "Huomautus: Tämän kokeen arvosanat jaetaan muiden opettajien kanssa. Muut voivat korvata tekemäsi muutokset.",
		"Exams.Import": "Tuonti",
		"Exams.Library": "Tenttikirjasto",
		"Exams.Scheduled": "Ajoitettu",
		"Exams.Ongoing": "Meneillään oleva",
		"Exams.Ungraded": "Arvostelematon",
		"Exams.Graded": "Arvosteltu",
		"Exams.Published": "Julkaistu",
		"Exams.ScheduledArchived": "Ajoitettu (Arkistoitu)",
		"Exams.OngoingArchived": "Meneillään oleva (Arkistoitu)",
		"Exams.UngradedArchived": "Arvostelematon (Arkistoitu)",
		"Exams.GradedArchived": "Arvosteltu (Arkistoitu)",
		"Exams.PublishedArchived": "Julkaistu (Arkistoitu)",
		"Exams.Library.NoExams": "Tenttikirjasto on tyhjä. Napsauta \"Luo uusi tentti\".",
		"Exams.Scheduled.NoExams": "Sinulla ei ole ajoitettuja tenttejä. \\nAjoita tentti tenttikirjastosta.",
		"Exams.Ongoing.NoExams": "Sinulla ei ole meneillään olevia tenttejä. \\nAloita tentti tenttikirjastosta.",
		"Exams.Ungraded.NoExams": "Sinulla ei ole arvostelemattomia tenttejä.",
		"Exams.Graded.NoExams": "Sinulla ei ole arvosteltuja tenttejä.",
		"Exams.Published.NoExams": "Sinulla ei ole julkaistuja tenttejä.",
		"Exams.OwnedBy": "Omistaa:",
		"Exams.SharedWith": "Käyttäjät, joilla on pääsy:",
		"Error.LoadingExams": "Virhe tenttien latauksessa",
		"Error.LoadingInvigilatorSettings": "Virhe valvojan asetusten latauksessa",
		"Error.Title": "Hups! Jotain meni pieleen",
		"Error.Message": "Virheviesti",
		"Error.SyncIssue": "Tietojen synkronoinnissa Digiexamiin ilmeni ongelma. Katso alta lisätietoja ongelmasta.",
		"Error.ContactUs": "Ota yhteyttä osoitteeseen support@digiexam.com, jos tarvitset tukea tämän ongelman ratkaisemiseksi.",
		"Error.ContactUsSkolon": "Ota yhteyttä osoitteeseen support@digiexam.se, jos tarvitset tukea tämän ongelman ratkaisemiseksi.",
		"Rubrics.Rubrics": "Pisteytysoppaat",
		"Rubrics.CreateRubric": "Luo uusi pisteytysopas",
		"Rubrics.Archive": "Arkisto",
		"Rubrics.RemoveRubric": "Poista pisteytysopas",
		"Rubrics.Library.NoRubrics": "Pisteytysopas-kirjastosi on tyhjä. Klikkaa \"Luo uusi pisteytysopas\".",
		"Rubrics.RemoveSharedRubric": "Poista jaettu pisteytysopas.",
		"Rubrics.ThePersonWhoSharedTheRubricWillStillHaveAccessToIt": "Pisteytysoppaan jakanut henkilö voi edelleen käyttää sitä.",
		"StartExamPopup.Start": "alkaa",
		"StartExamPopup.StartTime": "Aloitusaika",
		"StartExamPopup.Participants": "Osallistujat",
		"StartExamPopup.UseExamID": "Käytä tenttitunnusta",
		"StartExamPopup.ChooseGroup": "Valitse ryhmä",
		"StartExamPopup.StartExamNow": "Aloita tentti nyt",
		"StartExamPopup.ScheduleExam": "Ajoita tentti",
		"StartExamPopup.TooltipExamIDStartNow": " Saat tenttitunnuksen, kun klikkaat \\Aloita tentti nyt\\\". Muista jakaa tämä tenttitunnus kokeeseen osallistuvien opiskelijoiden kanssa.\"",
		"StartExamPopup.TooltipExamIDSchedule": "Saat koetunnuksen, kun klikkaat \\Ajoita tentti\\\". Muista jakaa tämä tenttitunnus kokeeseen osallistuvien opiskelijoiden kanssa.\"",
		"StartExamPopup.TooltipGroup": "Jos aloitat tentin tietylle ryhmälle, se näkyy automaattisesti opiskelijoille, kun he kirjautuvat sisään sovellukseen, eikä heidän tarvitse syöttää koetunnusta.",
		"StartExamPopup.LearnMore": "Opi lisää",
		"StartExamPopup.CouldNotStartExam": "Tenttiäsi ei voitu aloittaa/ajoittaa uudelleen.",
		"StartExamPopup.CouldNotLoadGroups": "Ryhmiäsi ei voitu ladata.",
		"StartExamPopup.NoGroups": "Et ole luonut yhtään ryhmää.",
		"StartExamPopup.StartDateNeeded": "Sinun on asetettava aloituspäivä.",
		"StartExamPopup.StartDateTooEarly": "Aloituspäivä ei voi olla aikaisempi kuin nyt.",
		"StartExamPopup.StartDateInvalid": "Päivämäärä on kirjoitettava muodossa \\YYYY-MM-DD\\\".\"",
		"StartExamPopup.StartNow": "Olet aloittamassa",
		"StartExamPopup.For": "varten",
		"StartExamPopUp.RequireInternetConnection": " Tämä koe sisältää verkkolinkkejä. Opiskelijalla tulee olla Internet-yhteys kokeen aikana päästäkseen linkkien sisältöön.",
		"StartExamPopup.IncompleteExam": "Tämä tenttipohja ei ole valmis. Täytä puuttuvat tiedot ennen aloitusta.",
		"StartExamPopup.EditExam": "Muokkaa tenttiä",

		// TODO: Translation needed
		"EditExamPopup.ExistingExams.Title": "Existing exams",
		"EditExamPopup.ExistingExams.Body": "You will be editing the exam template. Existing exams started from this template won't be affected. You can schedule or start a new exam from the updated template after making any changes.",

		"Invigilator.TooltipInfo": "Valvojat, jotka tunnetaan myös nimellä tentin valvojat, voivat saada pääsyn kokeen yleiskatsaukseen ajoitetun kokeen aikana auttaakseen opettajaa hallinnoinnissa. Voit määrittää, mitä käyttöoikeuksia heillä on, kuten tentin aloittaminen/pysäytys tai opiskelijoiden lukitseminen/lukituksen avaaminen jne.",
		"Invigilator.InviteInvigilator": "Kutsu valvoja",
		"Invigilator.InvigilatorInvitesPendingStartNow": "Kutsut lähetetään, kun klikkaat \\Aloita tentti nyt\\\".\"",
		"Invigilator.InvigilatorInvitesPendingSchedule": "Kutsut lähetetään, kun klikkaat \\Ajasta tentti\\\".\"",
		"Invigilator.AddInvigilatorInvite": "Lisää kutsu",
		"Invigilator.PerformInvigilatorInvite": "Kutsu valvoja",
		"Invigilator.PlannedInvigilatorInvites": "Valvojakutsut",
		"Invigilator.PendingInvigilatorInvites": "Kutsutut valvojat",
		"Invigilator.NoInvigilators": "Tähän tenttiin ei ole kutsuttu valvojia",
		"Invigilator.Settings.Title": "Valvoja-asetukset",
		"Invigilator.Settings.StartExam": "Aloita tentti",
		"Invigilator.Settings.EndExam": "Lopeta tentti",
		"Invigilator.Settings.LockUnlockExam": "Lukitse ja avaa tentti",
		"Invigilator.Settings.DownloadExam": "Lataa offline tenttitiedosto",
		"Invigilator.Error.AlreadyExists": "Sähköposti on jo lisätty",
		"Invigilator.Error.InvalidEmail": "Sähköpostiosoite ei ole voimassa",
		"Invigilator.Error.LoadError": "Valvojia ei voitu ladata",
		"Invigilator.Error.CreateError": "Ei voitu kutsua valvojaa",
		"Invigilator.Save": "Tallenna valvojan muutokset",
		"ExamInfoPopup.HasStarted": "on aloittanut",
		"ExamInfoPopup.HasBeenScheduled": "on ajoitettu",
		"ExamInfoPopup.WillAutoStart": "alkaa automaattisesti",
		"ExamInfoPopup.ShareExamId": "Sinun on jaettava tenttitunnus opiskelijoiden kanssa, jotka tekevät tentin.",
		"ExamInfoPopup.YouHaveStarted": "Olet aloittanut",
		"ExamInfoPopup.ForGroup": "ryhmälle",
		"ExamInfoPopup.Download": "Lataa offline-tenttitiedosto",
		"ExamInfoPopup.At": "at",
		"ExamInfoPopup.DownloadInfo1": "Tallenna offline-tenttitiedosto USB-asemalle ja tuo se tenttiin. USB-asemaa voidaan käyttää:",
		"ExamInfoPopup.DownloadInfo2": "- Aloita tentti opiskelijalle, joka ei voi aloittaa verkossa.",
		"ExamInfoPopup.DownloadInfo3": "-Muuta esteettömyysasetuksia.",
		"Overview.SeeAllOngoingExams": "Katso kaikki käynnissä olevat tentit",
		"Overview.SeeAllUngradedExams": "Katso kaikki arvostelemattomat tentit",
		"Overview.SeeAllScheduledExams": "Katso kaikki ajoitetut tentit",
		"SearchSortFilter.Sort": "Järjestä",
		"SearchSortFilter.DateModified": "Muokkauspäivämäärä",
		"SearchSortFilter.Title": "Otsikko",
		"SearchSortFilter.Subject": "Aihe",
		"SearchSortFilter.Description": "Kuvaus",
		"SearchSortFilter.StartTime": "Aloitusaika",
		"SearchSortFilter.FilterByTitleOrDescription": "Suodata otsikon tai kuvauksen mukaan",
		"SearchSortFilter.FilterByTitleOrSubject": "Suodata otsikon tai aiheen mukaan",
		"SearchSortFilter.FilterByTitleExamIDOrGroup": "Suodata otsikon, tenttitunnuksen tai ryhmän mukaan",
		"ExamEntry.DateModified": "Muokkauspäivämäärä",
		"ExamEntry.StartTime": "Aloitusaika",
		"RubricEntry.DateModified": "Muokkauspäivämäärä",
		"Spellcheck.SettingField.Title": "Salli oikeinkirjoituksen tarkistus",
		"Spellcheck.SettingField.Tooltip": "Salli yksittäisten opiskelijoiden oikeinkirjoituksen tarkistus napsauttamalla vasemmanpuoleisesta valikosta \\Opiskelijat\\, etsi oppilas ja muuta asetusta esteettömyysasetuksista.",
		"Spellcheck.Setting.0": "Vain valitut opiskelijat",
		"Spellcheck.Setting.1": "Kaikki opiskelijat",
		"Spellcheck.Setting.2": "Ei opiskelijoita",
		"ExamAdminEmails.AddTitle": "Lisää kokeen järjestelmänvalvojan sähköpostiosoite",
		"ExamAdminEmails.Title": "Kokeen ylläpitäjien sähköpostit",
		"TotalSumCopy.Label": "Käytä kokonaismäärää",
		"Import.Title": " Tuo tentit ja kysymykset",
		"Import.Paragraph.1": "Tuo tentit ja kysymykset ulkoisesta lähteestä ja käytä niitä Digiexamissa. Tuodut tentit avautuvat tenttikirjastoosi.",
		"Import.Paragraph.2": "Tuemme tällä hetkellä QTI 1.2, Common cartridge (IMSCC) ja Content package. Tämä tarkoittaa, että voit tuoda kysymyksiä esim. seuraavilta alustoilta: Canvas, Blackboard, Moodle, Sakai, Schoology and Powerschool.",
		"Import.Paragraph.3": "Huomaa, että tuemme vain kysymyksiä, jotka voidaan tuoda monivalinta-, monivastaus- tai tekstikysymyksenä. Lue lisää viennistä ja tuonnista kysymyksistämme",
		"Import.KnowledgeCenter": "Tietokeskus",
		"Import.DropArea.DropFilesHere": "Pudota tiedostoja tänne tai klikkaa selataksesi",
		"Import.DropArea.AllowedFileFormats": "Sallitut tiedostomuodot ovat .zip, .xml ja .imscc",
		"Import.Results.Title": "Tentit ja kysymykset",
		"Import.Results.ExamTitle": "Tentin otsikko",
		"Import.Results.ImportedQuestions": "Tuodut kysymykset",
		"Import.Results.ViewReport": "Katso raportti",
		"Import.Results.ReportTitle": "Raportti",
		"Import.Results.FilePath": "Tiedostopolku",
		"Import.Results.QuestionTitle": "Kysymysotsikko",
		"Import.Results.ImportedAs": "Tuodaan",
		"Import.Results.NotSupported": "Ei tuotu: kysymystyyppiä ei tueta",
		"Import.Results.CouldNotImport": "Ei tuotu: kysymystä ei voitu jäsentää",
		"Import.Importing": "Tuodaan",
		"Import.Restart": "Tuo toinen tiedosto",
		"Import.ViewImported": "Näytä tuodut tentit",
		"Uploadarea.InvalidFormat": "Seuraavissa tiedostoissa on virheelliset tiedostotyypit, eikä niitä voitu lisätä:",
		"QuestionType.UNIDENTIFIED": "Tuntematon kysymystyyppi",
		"QuestionType.TRUE_FALSE": "Oikein / Väärin",
		"QuestionType.MULTIPLE_RESPONSE": "Useita vastauksia",
		"QuestionType.MULTIPLE_CHOICE": "Useita vastauksia",
		"QuestionType.ESSAY": "Essee",
		"QuestionType.FILL_IN_BLANK": "Täytä tyhjä kohta",
		"QuestionType.FILL_IN_MULTIPLE_BLANKS": "Täytä tyhjät kohdat",
		"QuestionType.MULTIPLE_DROWDOWNS": "Useita avattavia valikkoja",
		"QuestionType.MATCHING": "Yhteensopiva",
		"QuestionType.NUMERICAL": "Numeerinen vastaus",
		"QuestionType.CALCULATED": "Laskettu",
		"QuestionType.FILE_UPLOAD": "Tiedoston lataaminen",
		"QuestionType.TEXT_ONLY": "Teksti",
		"QuestionType.EITHER_OR": "Joko tai",
		"QuestionType.HOT_SPOT": "Hot spot",
		"QuestionType.OPINION_SCALE": "Mielipideasteikko",
		"QuestionType.ORDERING": "Järjestykseen laittaminen",
		"QuestionType.QUIZ_BOWL": "Quiz Bowl",
		"QuestionType.SHORT_RESPONSE": "Lyhyt vastaus",
		"QuestionType.AUDIO_RESPONSE": "Äänivastaus",
		"QuestionType.SURVEY_MATRIX": "Tutkimusmatriisi",
		"QuestionType.PATTERN_MATCH": "Kuvion yhteensovitus",
		"OnlineResourcePopup.Title": "Otsikko",
		"OnlineResourcePopup.Cancel": "Peruuttaa",
		"OnlineResourcePopup.Add": "Lisätä",
		"OnlineResourcePopup.Edit": "Muokata",
		"OnlineResourcePopup.SaveLink": "Tallentaa",
		"OnlineResourcePopup.AddLink": "Lisää linkki",
		"OnlineResourcePopup.WholeDomain": "Koko verkkotunnus",
		"OnlineResourcePopup.SingleWebPage": "Yksittäinen verkkosivu",
		"OnlineResourcePopup.WebAddress": "Web-osoite (URL)",
		"OnlineResourcePopup.RequireInternetConnection": "Opiskelijalla on oltava Internet-yhteys kokeen aikana päästäkseen tämän linkin sisältöön.",
		"OnlineResourcePopup.VideoLink": "YouTube-linkki",
		"OnlineResourcePopup.AudioLink": "Audiolinkki",
		"OnlineResourcePopup.PdfLink": "PDF-linkki",
		"OnlineResourcePopup.WebPageLink": "nettilinkki",
		"OnlineResourcePopup.SingleWebPageTooltip": "Opiskelija pääsee vain valitsemallesi sivulle. Sivulla olevat linkit estetään ja opiskelijaa rajoitetaan siirtymästä muille sivuille.",
		"OnlineResourcePopup.WholeDomainTooltip": "Opiskelijalla on pääsy kaikille sivuille valitulla verkkotunnuksella. Linkit, jotka johtavat muilla verkkotunnuksilla sijaitseville sivuille estetään.",
		"OnlineResourcePopup.TitleError": "Sinun täytyy syöttää otsikko.",
		"OnlineResourcePopup.UrlErrorProtocol": "Voit linkittää vain web-osoitteeseen.",
		"OnlineResourcePopup.UrlErrorEmpty": "Sinun täytyy syöttää URL-osoite.",
		"OnlineResourcePopup.YoutubeError": "Tämä ei ole YouTube-video.",
		"OnlineResource.SuggestedTitle1": "Otsikkoehdotus:",
		"OnlineResource.unreachableURL": "Emme saa yhteyttä verkko-osoitteeseen. Oletko varma, että se on oikein?",
		"OnlineResource.InternetWarning": "Huomautus: Opiskelijoilla on oltava aktiivinen Internet-yhteys, jotta he voivat käyttää medialinkkejä.",
		"OnlineResourceAddMedia.Audio": "Audio",
		"OnlineResourceAddMedia.WebPage": "Nettisivu",
		"OnlineResourceAddMedia.AddMedia": "Lisää mediaa",
		"OnlineResourceEntry.WholeDomain": "Koko verkkotunnus",
		"OnlineResourceEntry.SingleWebPage": "Yksittäinen verkkosivu",
		"OnlineResourceEntry.Remove": "Poista",
		"OnlineResourceEntry.PopupTitle": "Tärkeää tietoa",
		"OnlineResourceEntry.PopupDescription": "Kun opiskelija avaa tämän linkin tentin aikana, hän ei voi siirtyä muille sivuille.",
		"OnlineResourceEntry.IconAlt.YouTube": "YouTube-linkki",
		"OnlineResourceEntry.IconAlt.Audio": "Audiolinkki",
		"OnlineResourceEntry.IconAlt.PDF": "PDF-linkki",
		"OnlineResourceEntry.IconAlt.WebPage": "nettilinkki",
		"StudentExtendedTime.Allow": "Salli lisäaikaa tenteille, joilla on aikaraja",
		"StudentExtendedTime.Limitless": "Poista aikaraja",
		"StudentExtendedTime.Percent": "Lisää aikaa",
		"StudentRoute.Error.ExtendedTimePercentNotEntered": "Syötä, kuinka prosenttia tenttiaikaa tulisi lisätä.",
		"StudentRoute.Error.ExtendedTimeStateNotSelected": "Poista aikaraja tai lisää aikaa prosentin mukaan.",
		"TextToSpeech.SettingField.Title": "Salli tekstistä puheeksi",
		"TextToSpeech.SettingField.Tooltip": "Tekstistä puheeksi sallii opiskelijoiden kuunnella tekstiä. Salli tekstistä puheeksi yksittäisille opiskelijoille napsauttamalla \\Opiskelijat\\\" vasemmanpuoleisessa valikossa, etsi oppilas ja muuta asetus Esteettömyysasetuksista.\"",
		"TextToSpeech.Setting.0": "Vain valitut opiskelijat",
		"TextToSpeech.Setting.1": "Kaikki opiskelijat",
		"TextToSpeech.Setting.2": "Ei opiskelijoita",
		"TextToSpeech.AllowForStudent": "Salli tekstistä puheeksi tälle opiskelijalle",
		"ExamDuration.TimeLimit": "Aikaraja",
		"ExamDuration.hours": "tuntia",
		"ExamDuration.minutes": "minuuttia",
		"ExamDuration.AllowExtended": "Salli lisää aikaa valituille opiskelijoille",
		"ExamDuration.TimeLimitToolTip": "Ajastin käynnistyy erikseen jokaiselle opiskelijalle, kun he aloittavat kokeen. Kun aika loppuu, tentti palautetaan automaattisesti. Opettaja voi pidentää tai poistaa yksittäisten opiskelijoiden aikarajaa kokeen aikana ja sen jälkeen. Tämä tehdään USB-laitteen avulla, joka sisältää offline-tenttitiedoston (ei tuettu iPadissa).",
		"ExamDuration.AllowExtendedToolTip": "Aikarajaa voi pidentää tai poistaa opiskelijolle, joilla on erityistarpeita. Siirry vasemmanpuoleisen valikon kohtaan \\Opiskelijat\\, etsi oppilas ja muuta asetus Esteettömyysasetuksista.",
		"ExamDuration.ErrorMessage": "Aikarajan on oltava pidempi kuin 0 minuuttia",
		"ExamDuration.On": "Päällä",
		"ExamDuration.Off": "Pois päältä",
		"UsbAudio.SettingField.Title": "Salli äänentoisto USB:stä",
		"UsbAudio.SettingField.Tooltip": "Äänentoisto USB-asemasta antaa opiskelijoille mahdollisuuden kuunnella äänitiedostoja sovelluksessa. Salli äänentoisto yksittäisille opiskelijoille napsauttamalla vasemmanpuoleisessa valikossa kohtaa \\Opiskelijat\\, etsi oppilas ja muuta asetusta Esteettömyysasetuksista.",
		"UsbAudio.Setting.0": "Vain valitut opiskelijat",
		"UsbAudio.Setting.1": "Kaikki opiskelijat",
		"UsbAudio.Setting.2": "Ei opiskelijoita",
		"UsbAudio.AllowForStudent": "Salli äänentoisto USB-asemalta",
		"ImmersiveReader.SettingField.Title": "Salli näytönlukuohjelman käyttö",
		"ImmersiveReader.SettingField.Tooltip.RequireInternetConnection": "Opiskelijalla on oltava Internet-yhteys kokeen aikana voidakseen käyttää näytönlukuohjelmaa.",
		"ImmersiveReader.SettingField.Tooltip.Description": "Näytönlukuohjelma on oppimistyökalu, joka tarjoaa opiskelijoille tukea lukemiseen visuaalisesti, kieliopillisesti ja sanallisesti. Salli näytönlukuohjelma yksittäisille opiskelijoille napsauttamalla vasemmanpuoleisessa valikossa kohtaa \\Opiskelijat\\, etsi opiskelija ja muuta asetusta esteettömyysasetuksista.",
		"ImmersiveReader.Setting.0": "Vain valitut opiskelijat",
		"ImmersiveReader.Setting.1": "Kaikki opiskelijat",
		"ImmersiveReader.Setting.2": "Ei opiskelijoita",
		"ImmersiveReader.AllowForStudent": "Salli näytönlukuohjelman käyttö",
		"GradingOptions": "Arvosteluvaihtoehdot",
		"GradingOptions.AllOrNothing": "Kaikki tai ei mitään",
		"GradingOptions.AllOrNothing.Tooltip": "Opiskelijan tulee vastata kaikkiin oikein saadakseen täydet pisteet. Jos opiskelija jättää vastaamatta johonkin tai vastaa johonkin väärin, opiskelija saa nolla pistettä.",
		"GradingOptions.RightMinusWrong": "Oikea miinus väärin",
		"GradingOptions.RightMinusWrong.Tooltip": "Opiskelija saa lisäpisteitä jokaisesta oikeasta vastauksesta ja miinus-pisteitä jokaisesta väärästä vastauksesta. Jokainen vastaus on kysymyksen maksimipisteiden arvoinen jaettuna mahdollisesti oikeiden vaihtoehtojen määrällä. Minimipisteet ovat nolla.",
		"GradingOptions.PointsPerResponse": "Pisteet per vastaus",
		"GradingOptions.PointsPerResponse.Tooltip": "Opiskelija saa lisäpisteitä jokaisesta oikeasta vastauksesta. Jokainen oikea vastaus on kysymyksen maksimipisteiden arvoinen jaettuna mahdollisesti oikeiden vaihtoehtojen määrällä. Pisteitä ei vähennetä virheellisistä vastauksista. Minimipisteet ovat nolla.",
		"GradingOptions.LimitedAlternatives": "Vaihtoehtoja rajoitetusti",
		"GradingOptions.LimitedAlternatives.Tooltip": "Rajoittaa kuinka monta vaihtoehtoa opiskelija voi valita kysymykseen vastatessaan.",
		"GradingOptions.LimitedAlternatives.ChoiceLimit": "Rajoita vaihtoehtoinen valinta:",
		"GradingOptions.LimitedAlternatives.NumberOfAlternatives": "Vaihtoehtojen määrä",
		"GradingOptions.LimitedAlternatives.ChoiceLimit.Error": "Valitse raja",
		"GradingOptions.LimitedAlternatives.Error": "Yhdessä monivastauskysymyksistäsi käytetään rajoitettuja vaihtoehtoja, mutta rajaa ei ole valittu. \\nValitse raja tai kytke rajoitetut vaihtoehdot pois päältä ratkaistaksesi ongelman.",
		"MasterTools.BulkChangeEmail.Verify": "Vahvista sähköpostin joukkomuutos",
		"MasterTools.BulkChangeEmail.Perform": "Suorita sähköpostin joukkomuutos",
		"MasterTools.BulkGdprDelete.Perform": "Suorita joukko GDPR-poisto",
		"MasterTools.BulkUnifyPassword.Perform": "Perform bulk unify password",
		"Communication.Title": "Viestintäasetukset",
		"Communication.Terms.Title": "Muutokset käyttöehtoihin",
		"Communication.System.Title": "Järjestelmäilmoitukset",
		"Communication.ProductUpdates.Title": "Tuotepäivitykset",
		"Communication.Promotional.Title": "Kampanjapäivitykset",
		"WordGap.MatchingOption.MatchingTitle": "Yhteensopiva",
		"WordGap.MatchingOption.CaseSensitive": "Tapauskohtainen",
		"WordGap.MatchingOption.ExactMatch": "Tarkka yhteensopivuus. Opiskelijan vastauksen tulee olla täsmälleen sama kuin oikea vastaus.",
		"WordGap.MatchingOption.Contains": "Sisältää. Opiskelijan vastauksen tulee sisältää oikea vastaus.",
		"WordGap.Validation.NoBlanks": "Kysymyksessä on oltava vähintään yksi sanaväli.",
		"WordGap.Validation.EmptyBlanks": "Word Gap ei voi olla tyhjä. Anna oikea vastaus.",
		"RedactedPii.StudentName": "[Poistettu opiskelija]",
		"Tooltip.Show": "Näytä työkaluvihje",
		"Tooltip.Note": "Huomautus!",
		"Tooltip.MoreInfo": "Lisätietoja Digiexamin tietokeskuksesta",
		"Accessibility.Flags.DisableFilters": "Poista suodattimet käytöstä",
		"Accessibility.Flags.Spellcheck": "Oikeinkirjoituksen tarkistus",
		"Accessibility.Flags.TextToSpeech": "Tekstistä puheeksi",
		"Accessibility.Flags.ExtendedTime": "Pidennetty aika",
		"Accessibility.Flags.ImmersiveReader": "Näytönlukuohjelma",
		"Accessibility.Flags.AudioFiles": "Äänitiedostot",
		"Accessibility.Header.UsedTools": "Tämän kokeen aikana käytetyt esteettömyystyökalut",
		"Accessibility.Header.UsedTools.WithName": "{0} käytti esteettömyystyökaluja tämän tentin aikana",
		"Navigation.SkipToMainContent": "Siirry pääsisältöön",
		"LiveView.UnlockAll": "Avaa kaikki",
		"LiveView.LockAll": "Lukitse kaikki",
		"LiveView.UnlockAll.Question": "Haluatko avata tentin kaikille opiskelijoille?",
		"LiveView.LockAll.Question": "Haluatko lukita tentin kaikille opiskelijoille?",
		"LiveView.UnlockExam": "Avaa tentti",
		"LiveView.LockExam": "Lukitse tentti",
		"LiveView.UnlockExam.Question": "Haluatko avata tentin niin, että opiskelija voi aloittaa sen?",
		"LiveView.LockExam.Question": "Haluatko lukita tentin ja estää opiskelijaa aloittamasta sitä?",
		"LiveView.Tooltip.LockedExamsTitle": "LockStatus: Avattu ja lukittu",
		"LiveView.Tooltip.LockedExams": "Opiskelija voi aloittaa vain avoinna olevan tentin. Heti kun opiskelija avaa tentin, se lukitaan ja sallitut materiaalit sekä avut ovat saatavilla. Kun opiskelija palauttaa tentin, se pysyy lukittuna, mutta opiskelijalla ei ole enää pääsyä tenttiin.",
		"LiveView.Tooltip.LockUnlockTitle": "Lukitse kaikki / Avaa kaikki",
		"LiveView.Tooltip.LockUnlock": "Tämän ominaisuuden avulla voit lukita tai avata kaikki tentit yhdellä painikkeella.",
		"LiveView.Tooltip.MoreInfo": "Lue lisää tästä ominaisuudesta.",
		"LiveView.Forbidden": "Sinulla ei ole oikeita oikeuksia tarkastella tenttiä.",
		"Schedule.Exam.Archive.Title": "Haluatko varmasti arkistoida {0}",
		"Schedule.Exam.Archive.Text": "Peruutuksesta tulee ilmoittaa valvojille ja opiskelijoille.",
		"ArticleList.Blog": "Blogi-postaukset",
		"ArticleList.Blog.ShowAll": "Näytä kaikki blogit ..",
		"ArticleList.Support": "Tukiartikkelit",
		"ArticleList.Support.ShowAll": "Näytä kaikki artikkelit ..",
		"ArticleList.Updated": "Päivitetty",
		"ArticleList.Created": "Luotu",
		"ArticleList.Title": "Otsikko",
		"ArticleList.NothingFound": "Artikkeleita ei löytynyt",
		"ArticleList.Error": "Artikkelien lataaminen epäonnistui",
		"ArticleList.New": "Uusi",
		"ArticleList.ShowMore": "Näytä lisää..",
		"Grading.ScoreBasedValidation.ValidNumberError": "Vain numerot ovat sallittuja pisteisiin perustuvassa arvioinnissa",
		"Grading.ScoreBasedValidation.MinError": "Pisteitä ei saa olla alle 0",
		"Grading.ScoreBasedValidation.MaxError": "Pisteet eivät saa olla suurempia kuin maksimipisteet",
		"Archive.NoExamTemplates": "Yhtään tenttipohjaa ei ole tällä hetkellä arkistoitu",
		"Archive.NoLiveExams": "Yhtään tenttiä ei ole tällä hetkellä arkistoitu",
		"Archive.NoRubrics": "Yhtään pisteytysopasta ei ole tällä hetkellä arkistoitu",
		"Archive.NoCourses": "Yhtään kurssia ei ole tällä hetkellä arkistoitu",
		"Archive.NoClasses": "Yhtään luokkaa ei ole tällä hetkellä arkistoitu",
		"Class.RemoveStudent": "Haluatko todella poistaa {0} \\ \"{1}?\"",
		"ImportStudents.Title.Master": "Tuo opiskelijat",
		"ImportStudents.Title.AccountManager": "Tuo opiskelijat {0}",
		"ImportStudents.SelectOrganization": "Valitse organisaatio",
		"ImportStudents.StudentCodesDisabled": "Opiskelijakoodit on poistettu käytöstä tällä organisaatiolla",
		"ImportStudents.Notice1": "Ilmoitus",
		"ImportStudents.Notice2": "Ennen kuin luot Digiexam-tilejä, varmista, että tileissä käytettävät sähköpostiosoitteet ovat voimassa, aktiivisia ja että ne voivat vastaanottaa sähköpostia.",
		"ImportStudents.Notice3": " Aloitussähköposti, jossa käyttäjä asettaa salasanan, lähetetään tiliä luotaessa. Jos sähköpostiosoite ei ole voimassa tai aktiivinen, esittelysähköpostia ei voida vastaanottaa eikä lähettää uudelleen.",
		// TODO: Translate ImportStudents.Notice4 to finnish
		"ImportStudents.Notice4": "A student can always use the 'Forgot password' to create a new password if they cannot find the introduction e-mail.",
		"ImportStudents.Details1": "Miten tuoda",
		"ImportStudents.Details2": "Liitä opiskelijatiedot laskentataulukosta ja muotoile ne alla olevan esimerkin mukaisesti. Kaksoiskappaleet poistetaan. Esteettömyysasetukset ovat valinnaisia, ja ne poistetaan käytöstä, jos niitä ei ole sisällytetty. Ota käyttöön yksi tai useampi asetus lisäämällä vastaava esteettömyyskoodi. Esteettömyysasetuksia voi muuttaa milloin tahansa opiskelijasivulta.",
		// TODO: Translate ImportStudents.Details3 to finnish
		"ImportStudents.Details3": "Enable one or more accessibility settings by including the respective accessibility code. Accessibility settings can be changed at any time from the student page.",
		"ImportStudents.AccessibilityCodes": "Esteettömyyskoodit",
		"ImportStudents.StudentCode": "Opiskelijakoodi",
		"ImportStudents.PasteLabel": "Liitä opiskelijat",
		"ImportStudents.Example.Title": "Muotoile esimerkki",
		"ImportStudents.Example.Show": "Näytä esimerkki",
		"ImportStudents.Example.Hide": "Piilota esimerkki",
		"ImportStudents.Example.Details": "Jane Doen opiskelijatiedot tekstistä puheeksi ja oikeinkirjoituksen tarkistus käytössä. Voit kokeilla muotoa kopioimalla ja liittämällä alla olevan esimerkin.",
		"ImportStudents.Example.Email": "jane.doe@mail.com",
		"ImportStudents.Example.FirstName": "Jane",
		"ImportStudents.Example.LastName": "Doe",
		"ImportStudents.Example.StudentCode": "doe2365",
		"ImportStudents.Example.AccessibilityCodes": "esteettömyyskoodit*",
		"ImportStudents.Example.Optional.Note": "* Valinnainen sisällyttää",
		"ImportStudents.Example.Password": "Ozqtge9D0y28",
		"ImportStudents.StudentsToImport": "Opiskelijat, jotka tuodaan",
		"ImportStudents.StudentsImportOngoing1": "Opiskelijan tuonti {0}, katso {1} lisätietoja varten.",
		"ImportStudents.StudentsImportOngoing2": "{0}/{1} opiskelijaa tuotu.",
		"ImportStudents.Error.InvalidEmail": "Sähköposti rivillä {0} ei kelpaa: {1}",
		"ImportStudents.Error.InvalidStudentCode": "Opiskelijakoodi rivillä {0} ei kelpaa: {1}",
		"ImportStudents.Error.InvalidFirstName": "Etunimi rivillä {0} ei kelpaa: {1}",
		"ImportStudents.Error.InvalidLastName": "Sukunimi rivillä {0} ei kelpaa: {1}",
		"ImportStudents.Error.InvalidAccessibilityCode": "Esteettömyyskoodi \\{0}\\\" rivillä {1} ei kelpaa: {2}\"",
		// TODO: Update ImportStudents.Error.InvalidColumnCount translation (see eng or sve translation)
		"ImportStudents.Error.InvalidColumnCount": "Rivillä {0} odotettiin olevan {1} tai {2} saraketta, mutta siinä oli {3}: {4}",
		"ImportStudents.Error.UnexpectedError": "Jotain meni pieleen opiskelijan tuonnin aikana. Ota yhteyttä tukeen, jos ongelma jatkuu.",
		"ImportStudents.Error.DuplicateEmails": "Löytyi kaksoiskappaleet riveissä: {0}",
		"CreateStudent.Error.UnexpectedError": "Jotain meni pieleen opiskelijaa luotaessa. Ota yhteyttä tukeen, jos ongelma jatkuu.",
		"CreateStudent.Error.InvalidEmail": "Sähköposti ei ole kelvollinen",
		"CreateStudent.Error.InvalidStudentCode": "Opiskelijakoodi ei ole kelvollinen",
		"CreateStudent.Error.InvalidFirstName": "Etunimi ei ole kelvollinen",
		"CreateStudent.Error.InvalidLastName": "Sukunimi ei ole kelvollinen",
		"ImportStudents.Error.InvalidPassword": "Salasana rivillä {0} ei kelpaa: {1}",
		"CreateStudent.Error.AlreadyExists": "Opiskelija tällä sähköpostilla on jo olemassa",
		"CreateStudent.CreateSuccess": "Opiskelija on luotu onnistuneesti,",
		"CreateStudent.CreateError": "Jotain meni pieleen opiskelijaa luotaessa,",
		"CreateStudent.CreateLink": "Klikkaa tästä saadaksesi lisätietoja.",
		"LeaveWarning.Title": "Haluatko varmasti poistua tältä sivulta?",
		"LeaveWarning.Body": "Tehtyjä muutoksia ei tallenneta.",
		"ProctoringSettings.Title": "Etävalvonta-asetukset",
		"ProctoringSettings.Warning": "Vähintään yksi asetus on otettava käyttöön.",
		"ProctoringSettings.Reset": "Palauta oletusasetuksiin",
		"ProctoringSettings.SaveSuccess": "Asetukset tallennettu",
		"ProctoringSettings.MobileCamera.Title": "Lisä mobiilikamera",
		"ProctoringSettings.MobileCamera.Body": "Lisää matkapuhelimen/älypuhelimen kameran istuntoon web-kameran lisäksi. Opiskelija yhdistää matkapuhelimen/älypuhelimen kameran istuntoon QR-koodin avulla.",
		"ProctoringSettings.AutomaticConclusion.Title": "Automaattinen istunnon johtopäätös",
		"ProctoringSettings.AutomaticConclusion.Body1": "Järjestelmä voi määrittää automaattisen johtopäätöksen (positiivinen tai negatiivinen) jokaiselle istunnolle \"Väärinkäytön seurantatietojen seuranta\" -asetuksen kriteerien perusteella.",
		"ProctoringSettings.AutomaticConclusion.Body2": "Jos asetus \"Seuraa väärinkäytön mittareita\" ei ole aktiivinen, kaikki istunnot asetetaan automaattisesti positiiviseen luokitukseen.",
		"ProctoringSettings.Chat.Title": "Opiskelija / etävalvonta chat",
		"ProctoringSettings.Chat.Body": "Keskustele opiskelijoiden kanssa kokeen aikana, tiedostojen jakaminen chatissa on tuettu.",
		"ProctoringSettings.FacePhoto.Title": "Ota kuva kasvoista kokeen alussa",
		"ProctoringSettings.FacePhoto.Body": "Opiskelija saa kehotteen valokuvata kasvonsa tentin alkaessa (jos tämä asetus ei ole käytössä, opiskelijan kasvot valokuvataan automaattisesti ensimmäisten minuuttien aikana tentin alkamisen jälkeen).",
		"ProctoringSettings.IdPhoto.Title": "Ota valokuva henkilöllisyystodistuksesta tentin alkaessa",
		"ProctoringSettings.IdPhoto.Body": "Opiskelija saa tentin alkaessa kehotteen ottaa kuvan henkilökortistaan.",
		"ProctoringSettings.RecordVideo.Title": "Tallenna opiskelijan näyttöä ja verkkokameraa kokeen aikana",
		"ProctoringSettings.RecordVideo.Body1": "Koko istunnon aikana tallennetaan videota web-kamerasta, tietokoneen näytöstä ja mobiilikamerasta.*",
		"ProctoringSettings.RecordVideo.Body2": "* Mobiilikameraa voidaan tallentaa vain, jos asetus \"Lisämo biilikamera\" on aktiivinen",
		"ProctoringSettings.ScreenCapture.Title": "Näytä opiskelijan tietokoneen näyttö kokeen aikana",
		"ProctoringSettings.ScreenCapture.Body": "Näyttää opiskelijan tietokoneen näytön livenä istunnon aikana.",
		"ProctoringSettings.TrackMetrics.Title": "Seuraa väärinkäytön mittareita",
		"ProctoringSettings.TrackMetrics.Body1": "Seuraa viitteitä oppilaiden väärinkäytöstä kokeen aikana seuraavien kriteerien perusteella:",
		"ProctoringSettings.TrackMetrics.Body2": "Jos web-kamera on poistettu käytöstä tai ei.",
		"ProctoringSettings.TrackMetrics.Body3": "Jos oppilaan kasvot ovat peitossa tai eivät katso web-kameraan.",
		"ProctoringSettings.TrackMetrics.Body4": "Jos web-kameran edessä on enemmän kuin yhdet kasvot.",
		"ProctoringSettings.TrackMetrics.Body5": "Jos opiskelijan kasvot eivät vastaa alkuperäistä otettua kasvokuvaa (kasvot valokuvataan automaattisesti ensimmäisten minuuttien aikana istunnon alkamisen jälkeen, jos kasvokuva on poistettu käytöstä kokeen alussa).",
		"ProctoringSettings.TrackMetrics.Body6": "Jos mikrofoni on mykistetty tai sen äänenvoimakkuus on alhainen.",
		"ProctoringSettings.TrackMetrics.Body7": "Jos kuuluu taustamelua.",
		"ProctoringSettings.TrackMetrics.Body8": "Jos verkkoyhteyttä ei ole.",
	};
}());
